(function () {
  var cartPaymentPreference = 'affirm';
  try {
    var savedPaymentPreference = window.sessionStorage.getItem('adan:payment-preference');
    if (['affirm', 'shop-pay', 'full'].indexOf(savedPaymentPreference) !== -1) cartPaymentPreference = savedPaymentPreference;
  } catch (error) { /* Keep the preference in memory if storage is unavailable. */ }

  function syncCartPaymentPreference() {
    document.querySelectorAll('[data-cart-payment-select]').forEach(function (select) {
      select.value = cartPaymentPreference;
    });
    document.querySelectorAll('[data-cart-payment-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cart-payment-panel') !== cartPaymentPreference;
    });
  }

  function saveCartPaymentPreference(preference) {
    if (['affirm', 'shop-pay', 'full'].indexOf(preference) === -1) return;
    cartPaymentPreference = preference;
    try {
      window.sessionStorage.setItem('adan:payment-preference', preference);
    } catch (error) { /* The current cart can still use this preference. */ }
    syncCartPaymentPreference();
    refreshAffirmMessaging();
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-cart-payment-select]')) saveCartPaymentPreference(event.target.value);
  });
  document.addEventListener('submit', function (event) {
    var scope = event.target.closest('[data-product-presale], [data-stage-product-focus]');
    if (!scope) return;
    var mode = scope.querySelector('[data-product-payment-mode][aria-pressed="true"], [data-stage-payment-mode][aria-pressed="true"]');
    var provider = scope.querySelector('[data-product-provider][aria-pressed="true"], [data-stage-financing-provider][aria-pressed="true"]');
    if (mode) saveCartPaymentPreference((mode.getAttribute('data-product-payment-mode') || mode.getAttribute('data-stage-payment-mode')) === 'full'
      ? 'full' : provider && (provider.getAttribute('data-product-provider') || provider.getAttribute('data-stage-financing-provider')));
  }, true);

  var affirmRefreshTimer;
  function refreshAffirmMessaging() {
    window.clearTimeout(affirmRefreshTimer);
    affirmRefreshTimer = window.setTimeout(function () {
      if (!window.affirm || !window.affirm.ui) return;
      window.affirm.ui.ready(function () {
        if (typeof window.affirm.ui.refresh === 'function') window.affirm.ui.refresh();
      });
    }, 100);
  }

  var WHEEL_STEP = 700;
  var PRODUCT_THUMBS_REVEAL_DELAY = 0;
  var PRODUCT_INFO_REVEAL_DELAY = 0;
  var PRODUCT_CLOSE_DURATION = 1080;
  var PRODUCT_CLOSE_PREP_DURATION = 560;
  var PRODUCT_IMAGE_RESTORE_SWAP_DELAY = 140;
  var DESKTOP_QUERY = '(min-width: 901px)';
  var instances = [];
  var cartDrawerInstance = null;
  var cartVariantQuantities = {};

  function setCartVariantState(items, notify) {
    var nextState = {};

    (items || []).forEach(function (item) {
      var variantId = item.variant_id || item.variantId || item.id;

      if (variantId) {
        nextState[String(variantId)] = Number(item.quantity) || 0;
      }
    });

    cartVariantQuantities = nextState;

    if (notify) {
      document.dispatchEvent(new window.CustomEvent('theme:cart-updated', {
        detail: { variantQuantities: cartVariantQuantities }
      }));
    }
  }

  function hydrateCartVariantState() {
    var stateElement = document.querySelector('[data-cart-variant-state]');

    if (!stateElement) return;

    try {
      setCartVariantState(JSON.parse(stateElement.textContent || '[]'), false);
    } catch (error) {
      setCartVariantState([], false);
    }
  }

  function isVariantInCart(variantId) {
    return Boolean(cartVariantQuantities[String(variantId)]);
  }

  function updateProductAddButton(button, variantId, available, addLabel) {
    if (!button) return;

    var inCart = isVariantInCart(variantId);

    button.setAttribute('data-variant-id', variantId || '');
    button.classList.toggle('is-in-cart', inCart);

    if (inCart) {
      button.disabled = false;
      button.type = 'button';
      button.textContent = 'In shopping bag';
      button.setAttribute('data-cart-drawer-open', '');
      button.setAttribute('aria-disabled', 'false');
      button.setAttribute('aria-label', 'Open shopping bag');
      button.title = 'This piece is already in your shopping bag.';
      return;
    }

    button.removeAttribute('data-cart-drawer-open');
    button.removeAttribute('aria-label');
    button.type = 'submit';
    button.disabled = !available;
    button.textContent = available ? addLabel : 'Sold out';
    button.setAttribute('aria-disabled', available ? 'false' : 'true');
    button.title = available ? '' : 'This product is sold out.';
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function supportsReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesignMode() {
    return window.Shopify && window.Shopify.designMode;
  }

  function isTypingTarget(target) {
    if (!target || !target.tagName) return false;

    var tagName = target.tagName.toLowerCase();
    return target.isContentEditable || tagName === 'input' || tagName === 'textarea' || tagName === 'select';
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeDetailValue(value) {
    if (value == null || value === false) return '';

    if (Array.isArray(value)) {
      return value.map(normalizeDetailValue).filter(Boolean).join(', ');
    }

    if (typeof value === 'object') {
      if (value.value != null) return normalizeDetailValue(value.value);
      if (value.label != null) return normalizeDetailValue(value.label);
      if (value.name != null) return normalizeDetailValue(value.name);
      return '';
    }

    var normalizedValue = String(value).trim();

    return normalizedValue === '0' ? '' : normalizedValue;
  }

  function formatCurrency(cents, currency) {
    var amount = (Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function toAjaxUrl(url) {
    var cleanUrl = (url || '').split('?')[0].split('#')[0];

    if (!cleanUrl) return '';
    if (cleanUrl.slice(-3) === '.js') return cleanUrl;

    return cleanUrl.replace(/\/$/, '') + '.js';
  }

  function createCartDrawer(drawer) {
    var panel = drawer.querySelector('.cart-drawer__panel');
    var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    var subtotalElement = drawer.querySelector('[data-cart-drawer-subtotal]');
    var countElement = drawer.querySelector('[data-cart-drawer-count]');
    var statusElement = drawer.querySelector('[data-cart-drawer-status]');
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-cart-drawer-open]'));
    var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';
    var addUrl = drawer.getAttribute('data-cart-add-url') || '/cart/add';
    var changeUrl = drawer.getAttribute('data-cart-change-url') || '/cart/change';
    var updateUrl = drawer.getAttribute('data-cart-update-url') || '/cart/update';
    var continueUrl = drawer.getAttribute('data-continue-url') || '/';
    var previousActiveElement = null;
    var statusTimer = 0;

    function formatMoney(cents, currency) {
      return formatCurrency(cents, currency);
    }

    function setStatus(message) {
      if (!statusElement) return;

      if (statusTimer) {
        window.clearTimeout(statusTimer);
        statusTimer = 0;
      }

      statusElement.textContent = message || '';
      statusElement.hidden = !message;

      if (message) {
        statusTimer = window.setTimeout(function () {
          statusElement.textContent = '';
          statusElement.hidden = true;
          statusTimer = 0;
        }, 3200);
      }
    }

    function setLoading(isLoading) {
      drawer.classList.toggle('is-loading', isLoading);
    }

    function rejectCartResponse(response, fallbackMessage) {
      return response.text().then(function (text) {
        var message = fallbackMessage;

        try {
          var json = JSON.parse(text);
          message = json.description || json.message || json.status || message;
        } catch (error) {
          message = text || message;
        }

        var error = new Error(message);
        error.status = response.status;
        throw error;
      });
    }

    function renderItem(item, currency) {
      var imageMarkup = '';
      var variantMarkup = '';
      var propertiesMarkup = '';
      var escapedKey = escapeHTML(item.key);
      var title = item.product_title || item.title || 'Product';
      var url = item.url || cartUrl;

      if (item.image) {
        imageMarkup =
          '<a class="cart-drawer__media" href="' + escapeHTML(url) + '">' +
            '<img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(title) + '" loading="lazy">' +
          '</a>';
      }

      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantMarkup = '<p class="cart-drawer__variant">' + escapeHTML(item.variant_title) + '</p>';
      }

      if (item.properties) {
        var visibleProperties = Object.keys(item.properties).filter(function (key) {
          return key.charAt(0) !== '_' && item.properties[key] !== null && String(item.properties[key]).trim() !== '';
        }).map(function (key) {
          return key + ': ' + item.properties[key];
        });

        if (visibleProperties.length) {
          propertiesMarkup = '<p class="cart-drawer__configuration-summary">' + escapeHTML(visibleProperties.join(' · ')) + '</p>';
        }
      }

      return (
        '<article class="cart-drawer__item" data-cart-drawer-item data-line-key="' + escapedKey + '">' +
          imageMarkup +
          '<div class="cart-drawer__item-content">' +
            '<a class="cart-drawer__item-title" href="' + escapeHTML(url) + '">' + escapeHTML(title) + '</a>' +
            variantMarkup +
            propertiesMarkup +
            '<p class="cart-drawer__price">' + escapeHTML(formatMoney(item.final_price, currency)) + '</p>' +
            '<div class="cart-drawer__item-actions">' +
              '<div class="cart-drawer__quantity">' +
                '<label for="CartDrawerQuantity-' + escapedKey + '">Qty</label>' +
                '<input id="CartDrawerQuantity-' + escapedKey + '" type="number" min="0" value="' + escapeHTML(item.quantity) + '" data-cart-drawer-quantity data-line-key="' + escapedKey + '">' +
              '</div>' +
              '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove data-line-key="' + escapedKey + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function getConfigurationId(item) {
      return item && item.properties && item.properties['_Configuration ID'];
    }

    function getCartDisplayGroups(items) {
      var groups = [];
      var configurationGroups = {};

      (items || []).forEach(function (item) {
        var configurationId = getConfigurationId(item);

        if (!configurationId) {
          groups.push({ type: 'item', item: item });
          return;
        }

        if (!configurationGroups[configurationId]) {
          configurationGroups[configurationId] = {
            type: 'configuration',
            id: configurationId,
            items: []
          };
          groups.push(configurationGroups[configurationId]);
        }

        configurationGroups[configurationId].items.push(item);
      });

      return groups;
    }

    function renderConfiguration(group, currency) {
      var parent = group.items.find(function (item) {
        var handle = item.handle || item.product_handle || '';
      return handle === 'custom-cuban-link-chain' ||
          handle === 'custom-cuban-link-bracelet' ||
          handle === '10k-yellow-gold-cuban-link-chain' ||
          item.product_title === 'Custom Cuban Link Chain' ||
          item.product_title === 'Custom Cuban Link Bracelet' ||
          item.product_title === '10K Yellow Gold Cuban Link Chain';
      }) || group.items[0];
      var lineTotal = group.items.reduce(function (total, item) {
        return total + (Number(item.final_line_price) || 0);
      }, 0);
      var properties = parent.properties || {};
      var summaryKeys = ['Clasp', 'Gold color', 'Finish', 'Lock', 'Button', 'Button shape', 'Gemstone', 'Engraving text'];
      var summary = summaryKeys.map(function (key) {
        return properties[key] ? key + ': ' + properties[key] : '';
      }).filter(Boolean).join(' · ');
      var keys = group.items.map(function (item) { return item.key; });
      var encodedKeys = encodeURIComponent(JSON.stringify(keys));
      var title = parent.product_title || parent.title || 'Custom Cuban Link Chain';
      var imageMarkup = '';

      if (parent.image) {
        imageMarkup =
          '<a class="cart-drawer__media" href="' + escapeHTML(parent.url || cartUrl) + '">' +
            '<img src="' + escapeHTML(parent.image) + '" alt="' + escapeHTML(title) + '" loading="lazy">' +
          '</a>';
      }

      return (
        '<article class="cart-drawer__item cart-drawer__item--configuration" data-cart-drawer-item data-configuration-id="' + escapeHTML(group.id) + '">' +
          imageMarkup +
          '<div class="cart-drawer__item-content">' +
            '<span class="cart-drawer__configuration-label">Made to order</span>' +
            '<a class="cart-drawer__item-title" href="' + escapeHTML(parent.url || cartUrl) + '">' + escapeHTML(title) + '</a>' +
            (parent.variant_title && parent.variant_title !== 'Default Title' ? '<p class="cart-drawer__variant">' + escapeHTML(parent.variant_title) + '</p>' : '') +
            (summary ? '<p class="cart-drawer__configuration-summary">' + escapeHTML(summary) + '</p>' : '') +
            '<p class="cart-drawer__price">' + escapeHTML(formatMoney(lineTotal, currency)) + '</p>' +
            '<div class="cart-drawer__item-actions">' +
              '<a class="cart-drawer__edit" href="' + escapeHTML(parent.url || cartUrl) + '">Edit choices</a>' +
              '<button type="button" class="cart-drawer__remove" data-cart-remove-configuration data-line-keys="' + escapeHTML(encodedKeys) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function renderCart(cart) {
      var displayGroups = getCartDisplayGroups(cart.items);
      var itemCount = displayGroups.reduce(function (total, group) {
        return total + (group.type === 'item' ? Number(group.item.quantity) || 1 : 1);
      }, 0);
      var itemLabel = itemCount + ' piece' + (itemCount === 1 ? '' : 's');
      var headerCountEls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));

      setCartVariantState(cart.items, true);

      drawer.classList.toggle('is-empty', itemCount === 0);

      if (countElement) {
        countElement.textContent = itemLabel;
      }

      headerCountEls.forEach(function (element) {
        element.textContent = itemCount;
      });

      openers.forEach(function (opener) {
        opener.setAttribute('aria-label', 'Shopping cart, ' + itemLabel);
      });

      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price, cart.currency);
      }

      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-affirm]'), function (message) {
        message.textContent = '';
        message.hidden = cart.total_price <= 0;
        message.setAttribute('data-amount', String(cart.total_price));
      });
      refreshAffirmMessaging();

      if (!itemsContainer) return;

      if (!displayGroups.length) {
        itemsContainer.innerHTML =
          '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
            '<p>Your cart is empty.</p>' +
            '<a href="' + escapeHTML(continueUrl) + '">Continue shopping</a>' +
          '</div>';
        return;
      }

      itemsContainer.innerHTML = displayGroups.map(function (group) {
        return group.type === 'configuration'
          ? renderConfiguration(group, cart.currency)
          : renderItem(group.item, cart.currency);
      }).join('');
    }

    function syncServerRenderedItems(html) {
      if (!html || !itemsContainer) return;

      var documentFragment = new window.DOMParser().parseFromString(html, 'text/html');
      var renderedItems = documentFragment.querySelector('[data-cart-drawer-items]');

      if (renderedItems) {
        itemsContainer.innerHTML = renderedItems.innerHTML;
      }
    }

    function getServerRenderedDrawer() {
      var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';

      return fetch(cartUrl + separator + 'section_id=cart-drawer', {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      })
        .then(function (response) {
          if (!response.ok) return '';
          return response.text();
        })
        .catch(function () {
          return '';
        });
    }

    function getCart(options) {
      return Promise.all([
        fetch(toAjaxUrl(cartUrl), {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }).then(function (response) {
          if (!response.ok) return rejectCartResponse(response, 'Cart could not be loaded.');
          return response.json();
        }),
        getServerRenderedDrawer()
      ])
        .then(function (results) {
          var cart = results[0];
          var serverRenderedDrawer = results[1];

          renderCart(cart);
          syncServerRenderedItems(serverRenderedDrawer);

          if (options && options.status) setStatus(options.status);
          return cart;
        });
    }

    function openDrawer() {
      if (drawer.classList.contains('is-open')) return;

      previousActiveElement = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      refreshAffirmMessaging();

      if (panel) {
        panel.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      setStatus('');

      if (previousActiveElement && previousActiveElement.focus) {
        previousActiveElement.focus();
      }
    }

    function refreshCart(options) {
      setLoading(true);

      return getCart(options)
        .then(function (cart) {
          if (options && options.open) {
            openDrawer();
          }

          return cart;
        })
        .catch(function (error) {
          setStatus(error.message || 'Cart could not be updated.');
        })
        .then(function (cart) {
          setLoading(false);
          return cart;
        });
    }

    function addItem(form) {
      var isStageProductForm = form && form.matches && form.matches('[data-stage-product-form]');
      var formStatus = isStageProductForm ? form.querySelector('[data-stage-product-form-status]') : null;

      if (formStatus) {
        formStatus.textContent = '';
        formStatus.hidden = true;
      }

      setLoading(true);

      return fetch(toAjaxUrl(form.getAttribute('action') || addUrl), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) return rejectCartResponse(response, 'This item could not be added.');
          return response.json();
        })
        .then(function () {
          return refreshCart({ open: true, status: 'Added to cart.' });
        })
        .catch(function (error) {
          var message = error.message || 'This item could not be added.';

          if (isStageProductForm) {
            if (
              (error.status === 401 || error.status === 429) &&
              (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
            ) {
              message = 'Shopify blocked this local preview cart request. Test add to cart from the remote theme preview.';
            }

            if (formStatus) {
              formStatus.textContent = message;
              formStatus.hidden = false;
            }
          } else {
            setStatus(message);
            openDrawer();
          }
        })
        .then(function (cart) {
          setLoading(false);
          return cart;
        });
    }

    function addItems(items) {
      setLoading(true);

      return fetch(toAjaxUrl(addUrl), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) return rejectCartResponse(response, 'This custom chain could not be added.');
          return response.json();
        })
        .then(function () {
          return refreshCart({ open: true, status: 'Custom chain added to your bag.' });
        })
        .catch(function (error) {
          setStatus(error.message || 'This custom chain could not be added.');
          openDrawer();
          throw error;
        })
        .then(function (cart) {
          setLoading(false);
          return cart;
        }, function (error) {
          setLoading(false);
          throw error;
        });
    }

    function removeItemKeys(keys) {
      var updates = {};

      (keys || []).forEach(function (key) {
        updates[key] = 0;
      });

      if (!Object.keys(updates).length) return Promise.resolve();

      setLoading(true);

      return fetch(toAjaxUrl(updateUrl), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (response) {
          if (!response.ok) return rejectCartResponse(response, 'Configuration could not be removed.');
          return response.json();
        })
        .then(function () {
          if (document.querySelector('.cart-page')) {
            window.location.reload();
            return null;
          }

          return getCart({ status: 'Configuration removed.' });
        })
        .catch(function (error) {
          setStatus(error.message || 'Configuration could not be removed.');
        })
        .then(function (cart) {
          setLoading(false);
          return cart;
        });
    }

    function changeItem(key, quantity) {
      setLoading(true);

      return fetch(toAjaxUrl(changeUrl), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(Number(quantity) || 0, 0)
        })
      })
        .then(function (response) {
          if (!response.ok) return rejectCartResponse(response, 'Cart could not be updated.');
          return response.json();
        })
        .then(function () {
          return getCart({ status: 'Cart updated.' });
        })
        .catch(function (error) {
          setStatus(error.message || 'Cart could not be updated.');
        })
        .then(function (cart) {
          setLoading(false);
          return cart;
        });
    }

    function isCartAddForm(form) {
      var action = form && form.getAttribute('action');

      if (!form || form.closest('[data-stage-product-shop-pay]')) return false;

      return Boolean(action && toAjaxUrl(action) === toAjaxUrl(addUrl));
    }

    function onDocumentClick(event) {
      var target = event.target;
      var opener = target.closest && target.closest('[data-cart-drawer-open]');
      var closeButton = target.closest && target.closest('[data-cart-drawer-close]');
      var removeButton = target.closest && target.closest('[data-cart-drawer-remove]');
      var removeConfigurationButton = target.closest && target.closest('[data-cart-remove-configuration]');

      if (opener) {
        event.preventDefault();
        refreshCart({ open: true });
        return;
      }

      if (closeButton && drawer.contains(closeButton)) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (removeButton && drawer.contains(removeButton)) {
        event.preventDefault();
        changeItem(removeButton.getAttribute('data-line-key'), 0);
        return;
      }

      if (removeConfigurationButton) {
        event.preventDefault();

        try {
          var lineKeysValue = removeConfigurationButton.getAttribute('data-line-keys') || '';
          var lineKeys;

          try {
            lineKeys = JSON.parse(decodeURIComponent(lineKeysValue));
          } catch (parseError) {
            lineKeys = lineKeysValue.split(',').filter(Boolean);
          }

          removeItemKeys(lineKeys);
        } catch (error) {
          setStatus('Configuration could not be removed.');
        }
      }
    }

    function onDocumentSubmit(event) {
      if (!isCartAddForm(event.target)) return;

      event.preventDefault();
      addItem(event.target);
    }

    function onDocumentChange(event) {
      var target = event.target;

      if (!target.matches || !target.matches('[data-cart-drawer-quantity]')) return;
      changeItem(target.getAttribute('data-line-key'), target.value);
    }

    function onDocumentKeyDown(event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        event.preventDefault();
        closeDrawer();
      }
    }

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('submit', onDocumentSubmit);
    document.addEventListener('change', onDocumentChange);
    document.addEventListener('keydown', onDocumentKeyDown);

    return {
      addItems: addItems,
      refreshCart: refreshCart,
      destroy: function () {
        document.removeEventListener('click', onDocumentClick);
        document.removeEventListener('submit', onDocumentSubmit);
        document.removeEventListener('change', onDocumentChange);
        document.removeEventListener('keydown', onDocumentKeyDown);
        document.body.classList.remove('cart-drawer-open');
      }
    };
  }

  function createStage(stage) {
    var scenes = Array.prototype.slice.call(stage.querySelectorAll('.collection-stage__scene'));
    var dots = Array.prototype.slice.call(stage.querySelectorAll('.collection-stage__rail span'));
    var productFocus = stage.querySelector('[data-stage-product-focus]');
    var productOverview = stage.querySelector('.stage-product-focus__overview');
    var productInfo = stage.querySelector('.stage-product-focus__info');
    var productDrawer = stage.querySelector('.stage-product-focus__drawer');
    var productDrawerContent = stage.querySelector('.stage-product-focus__drawer-content');
    var productDrawerActions = stage.querySelector('.stage-product-focus__actions');
    var productMobileScroll = stage.querySelector('[data-stage-product-mobile-scroll]');
    var productMobileHero = stage.querySelector('[data-stage-product-mobile-hero]');
    var productThumbs = stage.querySelector('[data-stage-product-thumbs]');
    var desktopQuery = window.matchMedia(DESKTOP_QUERY);
    var progress = 0;
    var phase = 'stage';
    var raf = 0;
    var locked = false;
    var touchY = 0;
    var previousHtmlOverflow = '';
    var previousBodyOverflow = '';
    var focusedCard = null;
    var focusedScene = null;
    var focusedProduct = null;
    var focusedOriginalImage = null;
    var focusedMainImageSrc = '';
    var activeImageSrc = '';
    var productRevealTimer = 0;
    var productThumbRevealTimer = 0;
    var productRevealFrame = 0;
    var productRevealId = 0;
    var productCloseTimer = 0;
    var productClosePrepTimer = 0;
    var productImageRestoreTimer = 0;
    var productScrollStateFrame = 0;
    var productScrollObserver = null;
    var hoveredCard = null;

    function maxProgress() {
      return Math.max(scenes.length - 1, 0);
    }

    function isEnabled() {
      return desktopQuery.matches && !supportsReducedMotion() && !isDesignMode() && scenes.length > 1;
    }

    function lockScroll() {
      if (locked) return;

      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      stage.classList.add('is-stage-locked');
      locked = true;
    }

    function unlockScroll() {
      if (!locked) return;

      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
      stage.classList.remove('is-stage-locked');
      locked = false;
    }

    function setActiveDot() {
      if (!dots.length) return;

      var activeIndex = Math.round(progress);
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function applySceneTransforms() {
      var max = maxProgress();

      stage.style.setProperty('--stage-progress', progress.toFixed(3));
      setActiveDot();

      scenes.forEach(function (scene, index) {
        var delta = index - progress;
        var distance = Math.abs(delta);
        var rotateY = clamp(delta * -28, -32, 32);
        var scale = 1 - Math.min(distance, 1.4) * 0.12;
        var opacity = 1 - Math.min(distance, 1.6) * 0.35;
        var brightness = 1 - Math.min(distance, 1.6) * 0.45;

        scene.style.transform = 'translate3d(' + (delta * 100).toFixed(3) + 'vw, 0, 0) rotateY(' + rotateY.toFixed(3) + 'deg) scale(' + scale.toFixed(3) + ')';
        scene.style.opacity = opacity.toFixed(3);
        scene.style.filter = 'brightness(' + brightness.toFixed(3) + ')';
        scene.style.zIndex = String(100 - Math.round(distance * 10));
        scene.setAttribute('aria-hidden', Math.round(progress) === index ? 'false' : 'true');
      });
    }

    function requestApply() {
      if (raf) return;

      raf = window.requestAnimationFrame(function () {
        raf = 0;
        applySceneTransforms();
      });
    }

    function setProgress(next) {
      progress = clamp(next, 0, maxProgress());
      requestApply();
      return progress;
    }

    function activateSceneForFocus(scene) {
      var sceneIndex = scenes.indexOf(scene);
      if (sceneIndex === -1) return;

      if (raf) {
        window.cancelAnimationFrame(raf);
        raf = 0;
      }

      progress = sceneIndex;
      applySceneTransforms();
    }

    function resetTransforms() {
      stage.style.removeProperty('--stage-progress');
      clearProductFocusGeometry();
      stage.classList.remove('is-stage-product-hovered');
      setHoveredCard(null);

      scenes.forEach(function (scene) {
        var grid = scene.querySelector('.product-grid--stage');

        if (grid) {
          grid.style.removeProperty('--stage-focus-origin-x');
          grid.style.removeProperty('--stage-focus-origin-y');
          grid.style.removeProperty('--stage-focus-translate-x');
          grid.style.removeProperty('--stage-focus-translate-y');
          grid.style.removeProperty('--stage-focus-scale');
          grid.style.removeProperty('--stage-focus-scroll-y');
        }

        scene.style.transform = '';
        scene.style.opacity = '';
        scene.style.filter = '';
        scene.style.zIndex = '';
        scene.removeAttribute('aria-hidden');
      });

    }

    function clearProductFocusGeometry() {
      if (!productFocus) return;

      productFocus.style.removeProperty('--stage-focus-thumb-left');
      productFocus.style.removeProperty('--stage-focus-thumb-top');
      productFocus.style.removeProperty('--stage-focus-thumb-width');
      productFocus.style.removeProperty('--stage-focus-info-top');
      productFocus.style.removeProperty('--stage-focus-info-left');
    }

    function getFocusedGrid() {
      if (!focusedScene) return null;
      return focusedScene.querySelector('.product-grid--stage');
    }

    function hasScrollableContent(element) {
      return Boolean(element && element.scrollHeight > element.clientHeight + 1);
    }

    function syncScrollContainerState(element) {
      if (!element) return;

      var isScrollable = Boolean(focusedProduct && hasScrollableContent(element));

      element.classList.toggle('is-scroll-static', !isScrollable);

      if (!isScrollable && element.scrollTop) {
        element.scrollTop = 0;
      }
    }

    function syncProductFocusScrollState() {
      productScrollStateFrame = 0;
      syncScrollContainerState(productOverview);
      syncScrollContainerState(productDrawer);
      setProductFocusScrollOffset();
    }

    function queueProductFocusScrollState() {
      if (productScrollStateFrame) return;

      productScrollStateFrame = window.requestAnimationFrame(syncProductFocusScrollState);
    }

    function setProductFocusScrollOffset() {
      var grid = getFocusedGrid();
      if (!grid) return;

      var scrollTop = productOverview && isEnabled() && hasScrollableContent(productOverview) ? productOverview.scrollTop : 0;

      grid.style.setProperty('--stage-focus-scroll-y', scrollTop.toFixed(3) + 'px');
    }

    function resetProductFocusScroll() {
      if (productMobileScroll) {
        productMobileScroll.scrollTop = 0;
      }

      if (productFocus) {
        productFocus.scrollTop = 0;
      }

      if (productOverview) {
        productOverview.scrollTop = 0;
      }

      if (productDrawer) {
        productDrawer.scrollTop = 0;
      }

      syncProductFocusScrollState();
    }

    function setText(selector, value) {
      if (!productFocus) return;

      Array.prototype.forEach.call(productFocus.querySelectorAll(selector), function (element) {
        element.textContent = value || '';
        element.hidden = !value;
      });
    }

    function setHtml(selector, value) {
      if (!productFocus) return;

      Array.prototype.forEach.call(productFocus.querySelectorAll(selector), function (element) {
        element.innerHTML = value || '';
        element.hidden = !value;
      });
    }

    function setPrice(selector, currentPrice, comparePrice) {
      if (!productFocus) return;

      Array.prototype.forEach.call(productFocus.querySelectorAll(selector), function (element) {
        element.innerHTML = '';
        element.hidden = !currentPrice;

        if (!currentPrice) return;

        var current = document.createElement('span');
        current.className = 'stage-product-focus__price-current';
        current.textContent = currentPrice;
        element.appendChild(current);

        if (comparePrice) {
          var compare = document.createElement('s');
          compare.className = 'stage-product-focus__price-compare';
          compare.textContent = comparePrice;
          element.appendChild(compare);
        }
      });
    }

    function setDetail(key, value) {
      if (!productFocus) return;

      var row = productFocus.querySelector('[data-stage-product-detail-row="' + key + '"]');
      var valueElement = productFocus.querySelector('[data-stage-product-' + key + ']');
      var normalizedValue = normalizeDetailValue(value);

      if (!row || !valueElement) return;

      valueElement.textContent = normalizedValue;
      row.hidden = !normalizedValue;
    }

    function updateDetailsSection() {
      if (!productFocus) return;

      var section = productFocus.querySelector('[data-stage-product-details-section]');
      if (!section) return;

      section.hidden = !productFocus.querySelector('.stage-product-focus__details div:not([hidden])');
    }

    function setStagePaymentMode(mode) {
      if (!productFocus) return;

      var showPlans = mode !== 'full';
      var modeButtons = Array.prototype.slice.call(productFocus.querySelectorAll('[data-stage-payment-mode]'));
      var financingPanel = productFocus.querySelector('[data-stage-financing-panel]');
      var payFullPanel = productFocus.querySelector('[data-stage-payment-full]');

      modeButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-stage-payment-mode') === (showPlans ? 'plans' : 'full');
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (financingPanel) financingPanel.hidden = !showPlans;
      if (payFullPanel) payFullPanel.hidden = showPlans;
    }

    function setStageFinancingProvider(provider) {
      if (!productFocus) return;

      var providerButtons = Array.prototype.slice.call(productFocus.querySelectorAll('[data-stage-financing-provider]'));
      var providerCopy = Array.prototype.slice.call(productFocus.querySelectorAll('[data-stage-financing-provider-copy]'));

      providerButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-stage-financing-provider') === provider;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      providerCopy.forEach(function (copy) {
        copy.hidden = copy.getAttribute('data-stage-financing-provider-copy') !== provider;
      });
      refreshAffirmMessaging();
    }

    function setFinancing(product) {
      if (!productFocus) return;

      var section = productFocus.querySelector('[data-stage-product-financing]');
      var shopPay = productFocus.querySelector('[data-stage-product-shop-pay]');
      var affirmMessage = productFocus.querySelector('[data-stage-product-affirm]');
      var payFullPrice = productFocus.querySelector('[data-stage-payment-full-price]');
      var priceCents = product ? Number(product.priceCents || 0) : 0;
      var formattedPrice = product ? normalizeDetailValue(product.price) : '';
      var paymentTerms = product ? normalizeDetailValue(product.paymentTerms) : '';

      if (!section) return;

      if (!priceCents && !paymentTerms) {
        section.hidden = true;

        if (shopPay) {
          shopPay.innerHTML = '';
          shopPay.hidden = true;
        }

        if (affirmMessage) {
          affirmMessage.textContent = '';
          affirmMessage.removeAttribute('data-amount');
          affirmMessage.hidden = true;
        }

        if (payFullPrice) payFullPrice.textContent = '';

        return;
      }

      section.hidden = false;
      setStagePaymentMode('plans');
      setStageFinancingProvider('shop-pay');

      if (payFullPrice) {
        payFullPrice.textContent = formattedPrice;
      }

      if (shopPay) {
        shopPay.innerHTML = paymentTerms;
        shopPay.hidden = !paymentTerms;
      }

      if (affirmMessage) {
        affirmMessage.textContent = '';
        affirmMessage.hidden = !priceCents;

        if (priceCents) {
          affirmMessage.setAttribute('data-amount', String(priceCents));
          affirmMessage.setAttribute('data-page-type', 'product');
        } else {
          affirmMessage.removeAttribute('data-amount');
        }
      }

      window.setTimeout(refreshAffirmMessaging, 0);
    }

    function setPurchaseRow(key, value) {
      if (!productFocus) return;

      var row = productFocus.querySelector('[data-stage-product-purchase-row="' + key + '"]');
      var valueElement = productFocus.querySelector('[data-stage-product-' + key + ']');
      var normalizedValue = normalizeDetailValue(value);

      if (!row || !valueElement) return;

      valueElement.textContent = normalizedValue;
      row.hidden = !normalizedValue;
    }

    function getStockText(product) {
      var quantity = product ? Number(product.inventoryQuantity) : 0;
      var isTracked = product && product.inventoryManagement;

      if (!product || !product.available) return '';
      if (!isTracked || quantity <= 0) return '';
      if (quantity === 1) return 'Only 1 left in stock';
      if (quantity <= 3) return 'Only ' + quantity + ' left in stock';

      return quantity + ' available';
    }

    function setPurchaseInfo(product) {
      if (!productFocus) return;

      var section = productFocus.querySelector('[data-stage-product-purchase-section]');
      var purchase = product && product.purchase ? product.purchase : {};
      var viewerCount = Number(purchase.viewerCount || 0);

      setPurchaseRow('availability', product ? (product.available ? 'In stock' : 'Sold out') : '');
      setPurchaseRow('stock', getStockText(product));
      setPurchaseRow('viewers', viewerCount > 0 ? viewerCount + ' customers are viewing this product' : '');
      setPurchaseRow('shipping', purchase.shipping);
      setPurchaseRow('returns', purchase.returns);

      if (section) {
        section.hidden = !productFocus.querySelector('.stage-product-focus__purchase-list div:not([hidden])');
      }
    }

    function getProductData(card) {
      var script = card.querySelector('[data-stage-product-json]');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return null;
      }
    }

    function getFocusedImage() {
      if (!focusedCard) return null;
      return focusedCard.querySelector('img');
    }

    function renderMobileHero(image) {
      if (!productMobileHero) return;

      productMobileHero.innerHTML = '';

      if (!image || !image.src) return;

      var heroImage = document.createElement('img');
      heroImage.src = image.src;
      heroImage.alt = image.alt || (focusedProduct && focusedProduct.title) || '';
      heroImage.loading = 'eager';
      heroImage.draggable = false;
      productMobileHero.appendChild(heroImage);
    }

    function setFocusedImage(image) {
      var imageElement = getFocusedImage();
      if (!imageElement || !image) return;

      activeImageSrc = image.src;
      imageElement.removeAttribute('srcset');
      imageElement.removeAttribute('sizes');
      imageElement.removeAttribute('data-src');
      imageElement.removeAttribute('data-srcset');
      imageElement.removeAttribute('data-sizes');
      imageElement.loading = 'eager';
      imageElement.setAttribute('src', image.src);
      imageElement.alt = image.alt || focusedProduct.title || '';
      renderMobileHero(image);
      renderThumbs();
    }

    function renderThumbs() {
      if (!productThumbs || !focusedProduct) return;

      productThumbs.innerHTML = '';
      renderMobileHero(
        focusedProduct.images && focusedProduct.images.length
          ? focusedProduct.images.find(function (image) { return image.src === activeImageSrc; }) || focusedProduct.images[0]
          : { src: activeImageSrc, alt: focusedProduct.title }
      );

      if (!focusedProduct.images || focusedProduct.images.length <= 1) {
        productThumbs.hidden = true;
        queueProductFocusScrollState();
        return;
      }

      productThumbs.hidden = false;

      focusedProduct.images.forEach(function (image, index) {
        var button = document.createElement('button');
        var img = document.createElement('img');

        button.type = 'button';
        button.className = 'stage-product-focus__thumb';
        button.setAttribute('aria-label', 'View ' + focusedProduct.title + ' image ' + (index + 1));
        button.classList.toggle('is-active', image.src === activeImageSrc);
        button.addEventListener('click', function () {
          setFocusedImage(image);
        });

        img.src = image.thumb || image.src;
        img.alt = image.alt || focusedProduct.title || '';
        img.loading = 'lazy';
        img.draggable = false;

        button.appendChild(img);
        productThumbs.appendChild(button);
      });

      queueProductFocusScrollState();
    }

    function getTriggerFromPoint(event) {
      if (!document.elementsFromPoint || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') {
        return null;
      }

      var elements = document.elementsFromPoint(event.clientX, event.clientY);

      for (var index = 0; index < elements.length; index += 1) {
        var trigger = elements[index].closest && elements[index].closest('[data-stage-product-trigger]');

        if (trigger && stage.contains(trigger)) {
          return trigger;
        }
      }

      return null;
    }

    function getTriggerForEvent(event) {
      var target = event.target;
      var directTrigger = target && target.closest ? target.closest('[data-stage-product-trigger]') : null;

      if (directTrigger && stage.contains(directTrigger)) {
        return directTrigger;
      }

      return getTriggerFromPoint(event);
    }

    function setHoveredCard(card) {
      if (hoveredCard === card) return;

      if (hoveredCard) {
        hoveredCard.classList.remove('is-hovered');
      }

      hoveredCard = card;

      if (hoveredCard) {
        hoveredCard.classList.add('is-hovered');
      }
    }

    function renderProductFocus() {
      if (!productFocus || !focusedProduct) return;
      if (productInfo) productInfo.scrollTop = 0;

      var price = focusedProduct.price || '';
      var productUrl = productFocus.querySelector('[data-stage-product-url]');
      var variantInput = productFocus.querySelector('[data-stage-product-variant]');
      var addButton = productFocus.querySelector('[data-stage-product-add]');

      setText('[data-stage-product-collection]', focusedProduct.collection);
      setText('[data-stage-product-title]', focusedProduct.title);
      setPrice('[data-stage-product-price]', price, focusedProduct.compareAtPrice);
      setHtml('[data-stage-product-description]', focusedProduct.description);
      setDetail('material', focusedProduct.details && focusedProduct.details.material);
      setDetail('karat', focusedProduct.details && focusedProduct.details.karat);
      setDetail('size', focusedProduct.details && focusedProduct.details.size);
      setDetail('length', focusedProduct.details && focusedProduct.details.length);
      setDetail('weight', focusedProduct.details && focusedProduct.details.weight);
      setDetail('gemstone', focusedProduct.details && focusedProduct.details.gemstone);
      setDetail('diamonds', focusedProduct.details && focusedProduct.details.diamonds);
      setDetail('variant', focusedProduct.variantTitle && focusedProduct.variantTitle !== 'Default Title' ? focusedProduct.variantTitle : '');
      setDetail('vendor', focusedProduct.vendor);
      setDetail('type', focusedProduct.type);
      updateDetailsSection();
      setFinancing(focusedProduct);
      setPurchaseInfo(focusedProduct);

      if (productUrl) {
        productUrl.href = focusedProduct.url || '#';
        productUrl.hidden = Boolean(focusedProduct.requiresRingSizing || focusedProduct.requiresConfiguration);
      }

      if (variantInput) {
        variantInput.value = focusedProduct.variantId || '';
      }

      if (addButton) {
        addButton.type = 'submit';
        addButton.onclick = null;

        if (focusedProduct.requiresRingSizing || focusedProduct.requiresConfiguration) {
          addButton.type = 'button';
          addButton.disabled = false;
          addButton.textContent = focusedProduct.requiresRingSizing ? 'Select ring size' : 'Customize';
          addButton.setAttribute('aria-disabled', 'false');
          addButton.title = focusedProduct.requiresRingSizing
            ? 'Choose your ring size on the product page'
            : 'Choose the product configuration on the product page';
          addButton.onclick = function () {
            var destination = new URL(focusedProduct.url, window.location.origin);
            var selectedMode = productFocus.querySelector('[data-stage-payment-mode][aria-pressed="true"]');
            var selectedProvider = productFocus.querySelector('[data-stage-financing-provider][aria-pressed="true"]');
            if (focusedProduct.variantId) destination.searchParams.set('variant', focusedProduct.variantId);
            if (selectedMode) destination.searchParams.set('payment_mode', selectedMode.getAttribute('data-stage-payment-mode'));
            if (selectedProvider) destination.searchParams.set('payment_provider', selectedProvider.getAttribute('data-stage-financing-provider'));
            window.location.href = destination.toString();
          };
        } else {
          updateProductAddButton(
            addButton,
            focusedProduct.variantId,
            focusedProduct.available,
            'Add to cart'
          );
        }
      }

      queueProductFocusScrollState();
    }

    function clearProductFocusContent() {
      var productUrl = productFocus && productFocus.querySelector('[data-stage-product-url]');
      var variantInput = productFocus && productFocus.querySelector('[data-stage-product-variant]');
      var addButton = productFocus && productFocus.querySelector('[data-stage-product-add]');

      if (!productFocus) return;

      setText('[data-stage-product-collection]', '');
      setText('[data-stage-product-title]', '');
      setPrice('[data-stage-product-price]', '', null);
      setHtml('[data-stage-product-description]', '');
      setDetail('material', '');
      setDetail('karat', '');
      setDetail('size', '');
      setDetail('length', '');
      setDetail('weight', '');
      setDetail('gemstone', '');
      setDetail('diamonds', '');
      setDetail('variant', '');
      setDetail('vendor', '');
      setDetail('type', '');
      updateDetailsSection();
      setFinancing(null);
      setPurchaseInfo(null);

      if (productUrl) {
        productUrl.href = '#';
        productUrl.hidden = false;
      }

      if (variantInput) {
        variantInput.value = '';
      }

      if (addButton) {
        addButton.type = 'submit';
        addButton.onclick = null;
        addButton.disabled = true;
        addButton.textContent = 'Add to cart';
        addButton.setAttribute('aria-disabled', 'true');
        addButton.title = '';
      }

      if (productThumbs) {
        productThumbs.innerHTML = '';
        productThumbs.hidden = true;
      }

      if (productMobileHero) {
        productMobileHero.innerHTML = '';
      }

      queueProductFocusScrollState();
    }

    function cancelProductReveal() {
      productRevealId += 1;

      if (productRevealTimer) {
        window.clearTimeout(productRevealTimer);
        productRevealTimer = 0;
      }

      if (productThumbRevealTimer) {
        window.clearTimeout(productThumbRevealTimer);
        productThumbRevealTimer = 0;
      }

      if (productRevealFrame) {
        window.cancelAnimationFrame(productRevealFrame);
        productRevealFrame = 0;
      }

    }

    function cancelProductClose() {
      if (productCloseTimer) {
        window.clearTimeout(productCloseTimer);
        productCloseTimer = 0;
      }

      if (productClosePrepTimer) {
        window.clearTimeout(productClosePrepTimer);
        productClosePrepTimer = 0;
      }

      if (productImageRestoreTimer) {
        window.clearTimeout(productImageRestoreTimer);
        productImageRestoreTimer = 0;
      }

      if (focusedCard) {
        focusedCard.classList.remove('is-restoring-image');
      }

      stage.classList.remove('is-product-closing');

      scenes.forEach(function (scene) {
        scene.classList.remove('is-product-closing');
      });
    }

    function shouldRestoreFocusedImageBeforeClose() {
      return Boolean(focusedMainImageSrc && activeImageSrc && activeImageSrc !== focusedMainImageSrc);
    }

    function prepareProductClose(callback) {
      var shouldDelay = false;

      if (productOverview && productOverview.scrollTop > 1) {
        shouldDelay = true;

        if (typeof productOverview.scrollTo === 'function') {
          productOverview.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          productOverview.scrollTop = 0;
        }

        setProductFocusScrollOffset();
      }

      if (shouldRestoreFocusedImageBeforeClose()) {
        shouldDelay = true;

        if (focusedCard) {
          focusedCard.classList.add('is-restoring-image');
        }

        productImageRestoreTimer = window.setTimeout(function () {
          productImageRestoreTimer = 0;
          restoreFocusedImage();

          if (focusedMainImageSrc) {
            activeImageSrc = focusedMainImageSrc;
          }

          renderThumbs();

          if (focusedCard) {
            focusedCard.classList.remove('is-restoring-image');
          }
        }, PRODUCT_IMAGE_RESTORE_SWAP_DELAY);
      }

      if (!shouldDelay) {
        callback();
        return;
      }

      productClosePrepTimer = window.setTimeout(function () {
        productClosePrepTimer = 0;
        resetProductFocusScroll();
        callback();
      }, PRODUCT_CLOSE_PREP_DURATION);
    }

    function queueProductThumbReveal() {
      var revealId = productRevealId;

      renderThumbs();

      productThumbRevealTimer = window.setTimeout(function () {
        if (revealId === productRevealId && focusedProduct) {
          stage.classList.add('is-product-thumbs-ready');
        }

        productThumbRevealTimer = 0;
      }, PRODUCT_THUMBS_REVEAL_DELAY);
    }

    function revealProductFocus(revealId) {
      if (revealId !== productRevealId || !focusedProduct) return;

      if (productRevealTimer) {
        window.clearTimeout(productRevealTimer);
        productRevealTimer = 0;
      }

      renderProductFocus();

      if (!desktopQuery.matches && productFocus) {
        if (productMobileScroll) {
          productMobileScroll.scrollTop = 0;
        }
      }

      productRevealFrame = window.requestAnimationFrame(function () {
        if (revealId === productRevealId) {
          stage.classList.add('is-product-ready');
        }
        productRevealFrame = 0;
      });
    }

    function queueProductReveal() {
      var revealId = productRevealId;

      productRevealTimer = window.setTimeout(function () {
        revealProductFocus(revealId);
      }, PRODUCT_INFO_REVEAL_DELAY);
    }

    function updateProductFocusTransform() {
      if (!focusedCard || !focusedScene) return;

      var grid = focusedScene.querySelector('.product-grid--stage');
      if (!grid) return;

      if (!desktopQuery.matches || supportsReducedMotion()) {
        grid.style.removeProperty('--stage-focus-origin-x');
        grid.style.removeProperty('--stage-focus-origin-y');
        grid.style.removeProperty('--stage-focus-translate-x');
        grid.style.removeProperty('--stage-focus-translate-y');
        grid.style.removeProperty('--stage-focus-scale');
        grid.style.removeProperty('--stage-focus-scroll-y');
        clearProductFocusGeometry();
        return;
      }

      var sceneRect = focusedScene.getBoundingClientRect();
      var gridWidth = grid.offsetWidth;
      var gridHeight = grid.offsetHeight;
      var cardWidth = focusedCard.offsetWidth;
      var cardHeight = focusedCard.offsetHeight;

      if (!gridWidth || !gridHeight || !cardWidth || !cardHeight) return;

      // offset* values stay in the original layout coordinate space even while
      // the grid is transformed. Measuring with getBoundingClientRect() here
      // would measure the previous focus transform and compound the offset on
      // every browser resize.
      var gridLeft = sceneRect.left + grid.offsetLeft;
      var gridTop = sceneRect.top + grid.offsetTop;
      var cardLeft = gridLeft + focusedCard.offsetLeft;
      var cardTop = gridTop + focusedCard.offsetTop;
      var cardCenterX = cardLeft + cardWidth / 2;
      var cardCenterY = cardTop + cardHeight / 2;
      var originX = ((cardCenterX - gridLeft) / gridWidth) * 100;
      var originY = ((cardCenterY - gridTop) / gridHeight) * 100;
      var isCompactDesktop = window.innerWidth < 1200;
      var sideInset = isCompactDesktop ? 24 : 56;
      var topInset = isCompactDesktop ? 80 : 96;
      var overviewWidth = productOverview ? productOverview.clientWidth : window.innerWidth * 0.62;
      var overviewGap = productOverview ? parseFloat(window.getComputedStyle(productOverview).columnGap) || 32 : 32;
      var minimumInfoWidth = isCompactDesktop ? 280 : 320;
      var maximumTileWidth = Math.max(cardWidth * 1.2, overviewWidth - overviewGap - minimumInfoWidth);
      var targetTileWidth = Math.min(window.innerWidth * 0.3, maximumTileWidth);
      var scale = clamp(targetTileWidth / cardWidth, 1.2, 2.65);
      var targetWidth = cardWidth * scale;
      var targetHeight = cardHeight * scale;
      var targetCenterX = sideInset + targetWidth / 2;
      var targetCenterY = topInset + targetHeight / 2;
      var thumbGap = window.innerWidth < 1100 ? 44 : 47;
      var thumbTop = topInset + targetHeight + thumbGap;

      grid.style.setProperty('--stage-focus-origin-x', originX.toFixed(3) + '%');
      grid.style.setProperty('--stage-focus-origin-y', originY.toFixed(3) + '%');
      grid.style.setProperty('--stage-focus-translate-x', (targetCenterX - cardCenterX).toFixed(3) + 'px');
      grid.style.setProperty('--stage-focus-translate-y', (targetCenterY - cardCenterY).toFixed(3) + 'px');
      grid.style.setProperty('--stage-focus-scale', scale.toFixed(3));

      if (productFocus) {
        productFocus.style.setProperty('--stage-focus-thumb-left', sideInset.toFixed(3) + 'px');
        productFocus.style.setProperty('--stage-focus-thumb-top', thumbTop.toFixed(3) + 'px');
        productFocus.style.setProperty('--stage-focus-thumb-width', targetWidth.toFixed(3) + 'px');
        productFocus.style.setProperty('--stage-focus-info-top', topInset.toFixed(3) + 'px');
        productFocus.style.setProperty('--stage-focus-info-left', (sideInset + targetWidth + 56).toFixed(3) + 'px');
      }

      setProductFocusScrollOffset();
      queueProductFocusScrollState();
    }

    function openProductFocus(card) {
      if (!productFocus) return;

      var product = getProductData(card);
      var scene = card.closest('.collection-stage__scene');
      var imageElement = card.querySelector('img');

      if (!product || !scene || !imageElement) return;

      closeProductFocus({ keepScrollLock: true, immediate: true });
      activateSceneForFocus(scene);
      stage.classList.remove('is-stage-product-hovered');
      setHoveredCard(null);

      focusedCard = card;
      focusedScene = scene;
      focusedProduct = product;
      focusedOriginalImage = {
        src: imageElement.currentSrc || imageElement.src,
        alt: imageElement.alt,
        srcset: imageElement.getAttribute('srcset'),
        sizes: imageElement.getAttribute('sizes')
      };
      focusedMainImageSrc = product.images && product.images[0] ? product.images[0].src : focusedOriginalImage.src;
      activeImageSrc = focusedMainImageSrc;

      productFocus.hidden = false;
      resetProductFocusScroll();
      stage.classList.remove('is-product-ready');
      stage.classList.remove('is-product-thumbs-ready');
      stage.classList.add('is-product-focused');
      scene.classList.add('is-product-focused');
      card.classList.add('is-focused');

      clearProductFocusContent();
      updateProductFocusTransform();
      lockScroll();
      cancelProductReveal();

      queueProductThumbReveal();
      queueProductReveal();
    }

    function restoreFocusedImage() {
      var imageElement = getFocusedImage();

      if (imageElement && focusedOriginalImage) {
        imageElement.src = focusedOriginalImage.src;
        imageElement.alt = focusedOriginalImage.alt || '';

        if (focusedOriginalImage.srcset) {
          imageElement.setAttribute('srcset', focusedOriginalImage.srcset);
        } else {
          imageElement.removeAttribute('srcset');
        }

        if (focusedOriginalImage.sizes) {
          imageElement.setAttribute('sizes', focusedOriginalImage.sizes);
        } else {
          imageElement.removeAttribute('sizes');
        }
      }
    }

    function finishProductClose(keepScrollLock) {
      restoreFocusedImage();

      if (focusedScene) {
        focusedScene.classList.remove('is-product-focused');
        focusedScene.classList.remove('is-product-closing');
        var grid = focusedScene.querySelector('.product-grid--stage');

        if (grid) {
          grid.style.removeProperty('--stage-focus-origin-x');
          grid.style.removeProperty('--stage-focus-origin-y');
          grid.style.removeProperty('--stage-focus-translate-x');
          grid.style.removeProperty('--stage-focus-translate-y');
          grid.style.removeProperty('--stage-focus-scale');
          grid.style.removeProperty('--stage-focus-scroll-y');
        }
      }

      clearProductFocusGeometry();

      if (focusedCard) {
        focusedCard.classList.remove('is-focused');
        focusedCard.classList.remove('is-restoring-image');
      }

      stage.classList.remove('is-product-focused');
      stage.classList.remove('is-product-ready');
      stage.classList.remove('is-product-thumbs-ready');
      stage.classList.remove('is-stage-product-hovered');
      stage.classList.remove('is-product-closing');
      setHoveredCard(null);

      if (productFocus) {
        if (productMobileScroll) {
          productMobileScroll.scrollTop = 0;
        }

        productFocus.scrollTop = 0;
        productFocus.hidden = true;
      }

      clearProductFocusContent();

      if (productOverview) {
        productOverview.scrollTop = 0;
      }

      if (productDrawer) {
        productDrawer.scrollTop = 0;
      }

      if (productThumbs) {
        productThumbs.innerHTML = '';
      }

      focusedCard = null;
      focusedScene = null;
      focusedProduct = null;
      focusedOriginalImage = null;
      focusedMainImageSrc = '';
      activeImageSrc = '';
      syncProductFocusScrollState();

      if (!keepScrollLock && (phase !== 'stage' || !isEnabled())) {
        unlockScroll();
      }
    }

    function startProductCloseAnimation(keepScrollLock) {
      stage.classList.add('is-product-closing');
      stage.classList.remove('is-product-focused');
      stage.classList.remove('is-product-ready');
      stage.classList.remove('is-product-thumbs-ready');
      stage.classList.remove('is-stage-product-hovered');
      setHoveredCard(null);

      if (focusedScene) {
        focusedScene.classList.add('is-product-closing');
        focusedScene.classList.remove('is-product-focused');
      }

      productCloseTimer = window.setTimeout(function () {
        productCloseTimer = 0;
        finishProductClose(keepScrollLock);
      }, PRODUCT_CLOSE_DURATION);
    }

    function closeProductFocus(options) {
      var keepScrollLock = options && options.keepScrollLock;
      var immediate = options && options.immediate;

      cancelProductReveal();
      cancelProductClose();

      if (!focusedCard && !focusedScene) {
        if (!keepScrollLock && (phase !== 'stage' || !isEnabled())) {
          unlockScroll();
        }

        return;
      }

      if (immediate || !desktopQuery.matches || supportsReducedMotion()) {
        finishProductClose(keepScrollLock);
        return;
      }

      prepareProductClose(function () {
        if (!focusedCard && !focusedScene) return;
        startProductCloseAnimation(keepScrollLock);
      });
    }

    function enterStage(startProgress) {
      phase = 'stage';
      stage.classList.remove('is-stage-released');
      setProgress(typeof startProgress === 'number' ? startProgress : progress);
      lockScroll();
    }

    function releaseStage() {
      phase = 'released';
      stage.classList.add('is-stage-released');
      unlockScroll();
    }

    function syncMode() {
      var enabled = isEnabled();

      stage.classList.toggle('collection-stage--static', !enabled);
      stage.classList.toggle('collection-stage--mobile', !desktopQuery.matches);

      if (!enabled) {
        unlockScroll();
        resetTransforms();
        setActiveDot();
        return;
      }

      applySceneTransforms();
      updateProductFocusTransform();

      if (phase === 'stage') {
        lockScroll();
      }
    }

    function onWheel(event) {
      if (!isEnabled()) return;
      if (focusedCard) return;

      if (phase === 'stage') {
        event.preventDefault();

        var before = progress;
        var after = setProgress(before + event.deltaY / WHEEL_STEP);
        var max = maxProgress();

        if (after >= max - 0.0001 && event.deltaY > 0 && before >= max - 0.0001) {
          releaseStage();
        }

        return;
      }

      if (phase === 'released' && window.scrollY <= 1 && event.deltaY < 0) {
        event.preventDefault();
        enterStage(maxProgress());
      }
    }

    function onTouchStart(event) {
      if (!event.touches.length) return;
      touchY = event.touches[0].clientY;
    }

    function onTouchMove(event) {
      if (focusedCard) return;
      if (!isEnabled() || phase !== 'stage' || !event.touches.length) return;

      event.preventDefault();

      var currentY = event.touches[0].clientY;
      var deltaY = touchY - currentY;
      var before = progress;
      var after = setProgress(before + deltaY / WHEEL_STEP);
      var max = maxProgress();

      touchY = currentY;

      if (after >= max - 0.0001 && deltaY > 0 && before >= max - 0.0001) {
        releaseStage();
      }
    }

    function onKeyDown(event) {
      if (focusedCard) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeProductFocus();
        }
        return;
      }

      if (!isEnabled() || phase !== 'stage' || isTypingTarget(event.target)) return;

      if (['ArrowDown', 'ArrowRight', 'PageDown', ' '].indexOf(event.key) !== -1) {
        event.preventDefault();

        var before = progress;
        var after = setProgress(before + 1);
        var max = maxProgress();

        if (after >= max - 0.0001 && before >= max - 0.0001) {
          releaseStage();
        }
      }

      if (['ArrowUp', 'ArrowLeft', 'PageUp'].indexOf(event.key) !== -1) {
        event.preventDefault();
        setProgress(progress - 1);
      }
    }

    function onClick(event) {
      var target = event.target;
      var closeButton = target && target.closest ? target.closest('[data-stage-product-close]') : null;
      var paymentModeButton = target && target.closest ? target.closest('[data-stage-payment-mode]') : null;
      var providerButton = target && target.closest ? target.closest('[data-stage-financing-provider]') : null;

      if (closeButton && stage.contains(closeButton)) {
        event.preventDefault();
        closeProductFocus();
        return;
      }

      if (paymentModeButton && productFocus && productFocus.contains(paymentModeButton)) {
        event.preventDefault();
        setStagePaymentMode(paymentModeButton.getAttribute('data-stage-payment-mode'));
        return;
      }

      if (providerButton && productFocus && productFocus.contains(providerButton)) {
        event.preventDefault();
        setStageFinancingProvider(providerButton.getAttribute('data-stage-financing-provider'));
        return;
      }

      var trigger = getTriggerForEvent(event);

      if (!trigger || !stage.contains(trigger)) return;

      var card = trigger.closest('[data-stage-product-card]');
      if (!card) return;

      event.preventDefault();
      openProductFocus(card);
    }

    function onMouseMove(event) {
      var trigger = !focusedCard && isEnabled() && phase === 'stage' ? getTriggerForEvent(event) : null;
      var card = trigger ? trigger.closest('[data-stage-product-card]') : null;

      setHoveredCard(card);
      stage.classList.toggle('is-stage-product-hovered', Boolean(trigger));
    }

    function onMouseLeave() {
      setHoveredCard(null);
      stage.classList.remove('is-stage-product-hovered');
    }

    function onResize() {
      // A partially scrolled overview can leave the text clipped below the
      // focused image after its columns are recalculated. Start both columns
      // from the same top edge whenever the selected-product layout changes.
      if (focusedCard && productOverview && productOverview.scrollTop) {
        productOverview.scrollTop = 0;
      }

      updateProductFocusTransform();
      queueProductFocusScrollState();
    }

    function onProductOverviewScroll() {
      if (!focusedCard) return;
      setProductFocusScrollOffset();
    }

    function onCartUpdated() {
      if (focusedProduct) {
        renderProductFocus();
      }
    }

    function destroy() {
      closeProductFocus({ keepScrollLock: true, immediate: true });
      unlockScroll();

      if (raf) {
        window.cancelAnimationFrame(raf);
      }

      if (productScrollStateFrame) {
        window.cancelAnimationFrame(productScrollStateFrame);
        productScrollStateFrame = 0;
      }

      if (productScrollObserver) {
        productScrollObserver.disconnect();
        productScrollObserver = null;
      }

      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', onResize);
      if (productOverview) {
        productOverview.removeEventListener('scroll', onProductOverviewScroll);
      }
      stage.removeEventListener('click', onClick);
      stage.removeEventListener('mousemove', onMouseMove);
      stage.removeEventListener('mouseleave', onMouseLeave);
      document.removeEventListener('theme:cart-updated', onCartUpdated);
      desktopQuery.removeEventListener('change', syncMode);
      resetTransforms();
    }

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onResize);
    if (productOverview) {
      productOverview.addEventListener('scroll', onProductOverviewScroll, { passive: true });
    }
    stage.addEventListener('click', onClick);
    stage.addEventListener('mousemove', onMouseMove);
    stage.addEventListener('mouseleave', onMouseLeave);
    document.addEventListener('theme:cart-updated', onCartUpdated);
    desktopQuery.addEventListener('change', syncMode);

    if (window.ResizeObserver) {
      productScrollObserver = new window.ResizeObserver(queueProductFocusScrollState);
      [productOverview, productMobileScroll, productMobileHero, productThumbs, productInfo, productDrawer, productDrawerContent, productDrawerActions].forEach(function (element) {
        if (element) {
          productScrollObserver.observe(element);
        }
      });
    }

    syncMode();

    return {
      destroy: destroy
    };
  }

  function initHorizontalStages() {
    instances.forEach(function (instance) {
      instance.destroy();
    });

    instances = Array.prototype.slice.call(document.querySelectorAll('[data-horizontal-stage]')).map(createStage);
  }

  function initCartDrawer() {
    if (cartDrawerInstance) {
      cartDrawerInstance.destroy();
      cartDrawerInstance = null;
    }

    var drawer = document.querySelector('[data-cart-drawer]');

    if (drawer) {
      cartDrawerInstance = createCartDrawer(drawer);
    }
  }

  function initProductPresale() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-presale]'), function (root) {
      if (root.productPresaleInitialized) return;

      root.productPresaleInitialized = true;
      var optionRequestController = null;
      var customChainBuilder = root.querySelector('[data-custom-chain-builder]');
      var calibratedClaspBuilder = root.querySelector('[data-calibrated-clasp-builder]');
      var ringSizing = root.querySelector('[data-ring-sizing]');
      var customProductNoun = root.getAttribute('data-custom-product-noun') || 'chain';
      var selectionParams = new URLSearchParams(window.location.search);
      var ringStorageKey = 'adan:ring-sizes:' + window.location.pathname;
      var savedRingSizes = {};
      try {
        savedRingSizes = JSON.parse(window.sessionStorage.getItem(ringStorageKey) || '{}') || {};
      } catch (error) { /* Size selection still works when storage is unavailable. */ }

      function updatePurchaseSelection() {
        var summary = root.querySelector('[data-purchase-selection]');
        if (!summary) return;
        var selections = Array.prototype.map.call(root.querySelectorAll('[data-ring-size-select]'), function (select) {
          var label = root.querySelector('label[for="' + select.id + '"]');
          return (label ? label.textContent.trim() : 'Ring size') + ': ' + select.value;
        });
        var mode = root.querySelector('[data-product-payment-mode][aria-pressed="true"]');
        var provider = root.querySelector('[data-product-provider][aria-pressed="true"]');
        if (mode) {
          selections.push(mode.getAttribute('data-product-payment-mode') === 'full'
            ? 'Pay in full'
            : (provider ? provider.textContent.trim() : 'Pay over time') + ' selected — choose at checkout');
        }
        summary.textContent = selections.join(' · ');
        summary.hidden = !selections.length;
      }

      function rememberPaymentSelection() {
        var pageUrl = new URL(window.location.href);
        var mode = root.querySelector('[data-product-payment-mode][aria-pressed="true"]');
        var provider = root.querySelector('[data-product-provider][aria-pressed="true"]');
        if (mode) pageUrl.searchParams.set('payment_mode', mode.getAttribute('data-product-payment-mode'));
        if (provider) pageUrl.searchParams.set('payment_provider', provider.getAttribute('data-product-provider'));
        saveCartPaymentPreference(mode && mode.getAttribute('data-product-payment-mode') === 'full'
          ? 'full' : provider && provider.getAttribute('data-product-provider'));
        window.history.replaceState(window.history.state, '', pageUrl.toString());
        updatePurchaseSelection();
      }

      function formatRingSize(value) {
        return Number.isInteger(value) ? String(value) : value.toFixed(1);
      }

      function updateRingSizing() {
        if (!ringSizing) return;

        var selects = Array.prototype.slice.call(ringSizing.querySelectorAll('[data-ring-size-select]'));
        var resizingRequested = selects.some(function (select) {
          return Math.abs(Number(select.value) - Number(select.getAttribute('data-ring-size-default'))) > 0.001;
        });
        var leadDays = Number(ringSizing.getAttribute('data-ring-sizing-lead-days')) || 7;
        var property = ringSizing.querySelector('[data-ring-resizing-property]');
        var note = ringSizing.querySelector('[data-ring-sizing-note]');

        if (property) {
          property.disabled = !resizingRequested;
          property.value = resizingRequested ? 'Yes — ' + leadDays + ' additional business days' : '';
        }

        if (note) {
          note.textContent = resizingRequested
            ? 'Complimentary professional resizing selected. Please allow ' + leadDays + ' additional business days.'
            : 'Current size selected. Choose another size for complimentary professional resizing.';
        }
        selects.forEach(function (select) { savedRingSizes[select.name] = select.value; });
        try {
          window.sessionStorage.setItem(ringStorageKey, JSON.stringify(savedRingSizes));
        } catch (error) { /* Keep the selected sizes in the cart form without storage. */ }
        updatePurchaseSelection();
      }

      function initializeRingSizing() {
        if (!ringSizing) return;

        Array.prototype.forEach.call(ringSizing.querySelectorAll('[data-ring-size-select]'), function (select) {
          var defaultSize = Number(select.getAttribute('data-ring-size-default'));
          var range = Number(select.getAttribute('data-ring-size-range')) || 3;

          if (!Number.isFinite(defaultSize)) return;

          select.innerHTML = '';
          for (var size = defaultSize - range; size <= defaultSize + range + 0.001; size += 0.5) {
            var normalizedSize = Math.round(size * 2) / 2;
            var option = document.createElement('option');
            option.value = formatRingSize(normalizedSize);
            option.textContent = formatRingSize(normalizedSize);
            option.selected = Math.abs(normalizedSize - defaultSize) < 0.001;
            select.appendChild(option);
          }
          var savedSize = savedRingSizes[select.name];
          if (Array.prototype.some.call(select.options, function (option) { return option.value === savedSize; })) {
            select.value = savedSize;
          }
        });

        updateRingSizing();
      }

      function getCustomChainSelections() {
        if (!customChainBuilder) return [];

        return Array.prototype.slice.call(customChainBuilder.querySelectorAll('[data-chain-choice]:checked'));
      }

      function selectedCalibratedClasp() {
        return calibratedClaspBuilder && calibratedClaspBuilder.querySelector('[data-calibrated-clasp-choice]:checked');
      }

      function selectMediaForCalibratedClasp(clasp) {
        if (!clasp) return;

        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
        var normalizedClasp = clasp.toLowerCase();
        var matchingMedia = mediaItems.find(function (item) {
          return (item.getAttribute('data-product-media-clasp') || '').toLowerCase() === normalizedClasp;
        });

        if (matchingMedia) {
          selectMedia(mediaItems.indexOf(matchingMedia));
        }
      }

      function updateCalibratedClaspBuilder() {
        if (!calibratedClaspBuilder) return;

        var form = root.querySelector('[data-product-form]');
        var variantInput = form && form.querySelector('[name="id"]');
        var addButton = form && form.querySelector('[data-product-add]');
        var widthSelect = Array.prototype.slice.call(root.querySelectorAll('[data-product-option-select]')).find(function (select) {
          return (select.name || '').toLowerCase().indexOf('width') !== -1;
        });
        var width = Number.parseFloat(widthSelect && widthSelect.value) || 0;
        var diamondChoice = calibratedClaspBuilder.querySelector('[data-calibrated-diamond-clasp]');
        var diamondLabel = calibratedClaspBuilder.querySelector('[data-calibrated-diamond-clasp-label]');
        var diamondAllowed = width >= 4 && width <= 6;

        if (diamondChoice) diamondChoice.disabled = !diamondAllowed;
        if (diamondLabel) {
          diamondLabel.classList.toggle('is-disabled', !diamondAllowed);
          diamondLabel.setAttribute('aria-disabled', diamondAllowed ? 'false' : 'true');
        }
        if (!diamondAllowed && diamondChoice && diamondChoice.checked) {
          var boxChoice = calibratedClaspBuilder.querySelector('[data-calibrated-clasp-choice]:not([data-calibrated-diamond-clasp])');
          if (boxChoice) boxChoice.checked = true;
        }

        var selected = selectedCalibratedClasp();
        selectMediaForCalibratedClasp(selected && selected.value);
        var basePrice = Number(variantInput && variantInput.getAttribute('data-price-cents')) || 0;
        var addonPrice = Number(selected && selected.getAttribute('data-addon-price-cents')) || 0;
        var total = basePrice + addonPrice;
        var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
        var totalElement = calibratedClaspBuilder.querySelector('[data-calibrated-clasp-total]');
        var summaryElement = calibratedClaspBuilder.querySelector('[data-calibrated-clasp-summary]');
        var displayedPrice = root.querySelector('[data-product-selected-price] .price');
        var payFullPrice = root.querySelector('[data-product-pay-full] strong');
        var affirmMessage = root.querySelector('.affirm-as-low-as');
        if (totalElement) totalElement.textContent = formatCurrency(total, currency);
        if (summaryElement) summaryElement.textContent = selected ? selected.value : 'Box Lock';
        if (displayedPrice && total > 0) displayedPrice.textContent = formatCurrency(total, currency);
        if (payFullPrice && total > 0) payFullPrice.textContent = formatCurrency(total, currency);
        if (affirmMessage) affirmMessage.setAttribute('data-amount', String(total));
        refreshAffirmMessaging();

        if (addButton && variantInput && !isVariantInCart(variantInput.value) && basePrice > 0) {
          var label = 'Add to cart · ' + formatCurrency(total, currency);
          addButton.textContent = label;
          addButton.setAttribute('data-add-label', label);
        }
      }

      function buildCalibratedClaspCartItems() {
        var form = root.querySelector('[data-product-form]');
        var variantInput = form && form.querySelector('[name="id"]');
        var quantityInput = form && form.querySelector('[name="quantity"]');
        var selected = selectedCalibratedClasp();
        if (!variantInput || !variantInput.value || !selected) return [];

        var quantity = Math.max(Number(quantityInput && quantityInput.value) || 1, 1);
        var configurationId = 'CC-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
        var items = [{
          id: Number(variantInput.value),
          quantity: quantity,
          properties: {
            '_Configuration ID': configurationId,
            'Clasp': selected.value
          }
        }];
        var addonVariantId = Number(selected.getAttribute('data-addon-variant-id'));

        if (addonVariantId) {
          items.push({
            id: addonVariantId,
            quantity: quantity,
            properties: {
              '_Configuration ID': configurationId,
              '_Configuration parent': String(variantInput.value)
            }
          });
        }

        return items;
      }

      function hydrateCustomChainFromQuery() {
        if (!customChainBuilder || !window.URLSearchParams) return;

        var params = new URLSearchParams(window.location.search);
        ['chain_color', 'chain_finish', 'chain_lock', 'chain_button'].forEach(function (fieldName) {
          var requestedValue = params.get(fieldName);
          if (!requestedValue) return;

          var matchingChoice = Array.prototype.slice.call(customChainBuilder.querySelectorAll('input[name="' + fieldName + '"]')).find(function (choice) {
            return choice.value === requestedValue;
          });

          if (!matchingChoice) return;
          matchingChoice.checked = true;

          if (matchingChoice.hasAttribute('data-chain-media-color')) {
            selectMediaForChainColor(matchingChoice.getAttribute('data-chain-media-color'));
          }
        });

        if (params.get('chain_engraving') === 'Engraving') {
          var engravingChoice = customChainBuilder.querySelector('input[data-chain-group="Engraving"]');
          if (engravingChoice) engravingChoice.checked = true;
        }

        [
          ['button_shape', 'Button shape'],
          ['gemstone', 'Gemstone'],
          ['engraving_text', 'Engraving text']
        ].forEach(function (mapping) {
          var requestedValue = params.get(mapping[0]);
          var propertyField = customChainBuilder.querySelector('[data-chain-property="' + mapping[1] + '"]');
          if (!requestedValue || !propertyField) return;

          var matchingOption = propertyField.tagName === 'SELECT' && Array.prototype.slice.call(propertyField.options).some(function (option) {
            return option.value === requestedValue;
          });
          if (propertyField.tagName !== 'SELECT' || matchingOption) propertyField.value = requestedValue;
        });
      }

      function syncCustomChainRestrictions() {
        if (!customChainBuilder) return;

        var lengthSelect = Array.prototype.slice.call(root.querySelectorAll('[data-product-option-select]')).find(function (select) {
          return (select.name || '').toLowerCase().indexOf('length') !== -1;
        });
        var selectedLength = Number.parseFloat(lengthSelect && lengthSelect.value) || 0;

        Array.prototype.forEach.call(customChainBuilder.querySelectorAll('[data-chain-min-length]'), function (choice) {
          var minimumLength = Number(choice.getAttribute('data-chain-min-length')) || 0;
          var isUnavailable = selectedLength < minimumLength;
          var label = choice.closest('[data-chain-min-length-choice]');

          choice.disabled = isUnavailable;
          if (label) {
            label.classList.toggle('is-disabled', isUnavailable);
            label.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
          }

          if (isUnavailable && choice.checked) {
            var defaultChoice = customChainBuilder.querySelector('input[name="' + choice.name + '"]:not([data-chain-min-length])');
            if (defaultChoice) defaultChoice.checked = true;
          }
        });
      }

      function updateCustomChainBuilder() {
        if (!customChainBuilder) return;

        syncCustomChainRestrictions();
        var form = root.querySelector('[data-product-form]');
        var variantInput = form && form.querySelector('[name="id"]');
        var addButton = form && form.querySelector('[data-product-add]');
        var selections = getCustomChainSelections();
        var basePrice = Number(variantInput && variantInput.getAttribute('data-price-cents')) || 0;
        var addonPrice = selections.reduce(function (total, selection) {
          return total + (Number(selection.getAttribute('data-addon-price-cents')) || 0);
        }, 0);
        var total = basePrice + addonPrice;
        var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
        var totalElement = customChainBuilder.querySelector('[data-chain-total]');
        var summaryElement = customChainBuilder.querySelector('[data-chain-summary]');
        var selectedDetails = selections.map(function (selection) {
          var group = selection.getAttribute('data-chain-group');
          var value = selection.value;
          return group === 'Engraving' ? 'Personal engraving' : value;
        }).filter(Boolean);

        Array.prototype.forEach.call(customChainBuilder.querySelectorAll('[data-chain-detail-panel]'), function (panel) {
          var detailName = panel.getAttribute('data-chain-detail-panel');
          var isVisible = selections.some(function (selection) {
            return selection.getAttribute('data-chain-detail') === detailName;
          });
          panel.hidden = !isVisible;
        });

        var affirmMessage = root.querySelector('.affirm-as-low-as');
        if (affirmMessage) affirmMessage.setAttribute('data-amount', String(total));
        refreshAffirmMessaging();
        if (totalElement) totalElement.textContent = formatCurrency(total, currency);
        if (summaryElement) summaryElement.textContent = selectedDetails.join(' · ');
        var configuredPrice = root.querySelector('[data-product-selected-price] .price');
        if (configuredPrice && total > 0) configuredPrice.textContent = formatCurrency(total, currency);

        if (addButton && variantInput && !isVariantInCart(variantInput.value)) {
          var label = 'Add custom ' + customProductNoun + ' · ' + formatCurrency(total, currency);
          addButton.textContent = label;
          addButton.setAttribute('data-add-label', label);
        }

        selectCustomChainPreview();
      }

      function buildCustomChainCartItems() {
        var form = root.querySelector('[data-product-form]');
        var variantInput = form && form.querySelector('[name="id"]');
        var quantityInput = form && form.querySelector('[name="quantity"]');
        var selections = getCustomChainSelections();
        var configurationId = 'CC-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
        var properties = { '_Configuration ID': configurationId };
        var items = [];

        selections.forEach(function (selection) {
          var group = selection.getAttribute('data-chain-group');

          if (group === 'Engraving') {
            properties.Engraving = 'Yes';
          } else if (group) {
            properties[group] = selection.value;
          }
        });

        Array.prototype.forEach.call(customChainBuilder.querySelectorAll('[data-chain-detail-panel]:not([hidden]) [data-chain-property]'), function (field) {
          if (field.value && field.value.trim()) {
            properties[field.getAttribute('data-chain-property')] = field.value.trim();
          }
        });

        items.push({
          id: Number(variantInput.value),
          quantity: Math.max(Number(quantityInput && quantityInput.value) || 1, 1),
          properties: properties
        });

        selections.forEach(function (selection) {
          var addonVariantId = Number(selection.getAttribute('data-addon-variant-id'));

          if (!addonVariantId) return;

          items.push({
            id: addonVariantId,
            quantity: 1,
            properties: {
              '_Configuration ID': configurationId,
              '_Configuration parent': String(variantInput.value)
            }
          });
        });

        return items;
      }

      function selectMedia(index) {
        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
        var mediaButtons = Array.prototype.slice.call(root.querySelectorAll('[data-product-media-thumb]'));
        var galleryCount = root.querySelector('[data-product-gallery-count]');
        var selectedItem = mediaItems[index];

        mediaItems.forEach(function (item, itemIndex) {
          var isActive = itemIndex === index;
          var video = item.querySelector('video');

          item.hidden = !isActive;
          item.classList.toggle('is-active', isActive);

          if (!isActive && video && typeof video.pause === 'function') {
            video.pause();
          }
        });

        mediaButtons.forEach(function (button, buttonIndex) {
          var isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (galleryCount && selectedItem && selectedItem.hasAttribute('data-chain-builder-media')) {
          galleryCount.textContent = 'Live preview';
        } else if (galleryCount) {
          var standardMedia = mediaItems.filter(function (item) {
            return !item.hasAttribute('data-chain-builder-media');
          });
          var standardIndex = standardMedia.indexOf(selectedItem);
          galleryCount.textContent = String(Math.max(standardIndex, 0) + 1).padStart(2, '0') + ' / ' + String(Math.max(standardMedia.length, 1)).padStart(2, '0');
        }
      }

      function selectMediaForChainColor(color) {
        if (!color) return;

        var normalizedColor = color.toLowerCase();
        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
        var matchingMedia = mediaItems.find(function (item) {
          return (item.getAttribute('data-product-media-color') || '').toLowerCase() === normalizedColor;
        });

        if (matchingMedia) {
          selectMedia(Number(matchingMedia.getAttribute('data-product-media')) || 0);
        } else if (normalizedColor === 'yellow gold') {
          selectMedia(0);
        }
      }

      function chainLengthGroup(value) {
        var length = Number.parseFloat(value) || 0;
        if (length <= 22) return 'short';
        if (length <= 30) return 'medium';
        return 'long';
      }

      function chainWidthGroup(value) {
        var width = Number.parseFloat(value) || 0;
        if (width <= 10) return 'narrow';
        if (width <= 14) return 'medium';
        return 'wide';
      }

      function selectCustomChainPreview() {
        if (!customChainBuilder) return;

        var previewItems = Array.prototype.slice.call(root.querySelectorAll('[data-chain-builder-media]'));
        var colorChoice = customChainBuilder.querySelector('input[name="chain_color"]:checked');
        var color = colorChoice ? colorChoice.value : 'Yellow Gold';
        var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-product-option-select]'));
        var lengthSelect = optionSelects.find(function (select) {
          return (select.name || '').toLowerCase().indexOf('length') !== -1;
        });
        var widthSelect = optionSelects.find(function (select) {
          return (select.name || '').toLowerCase().indexOf('width') !== -1;
        });
        var lengthGroup = chainLengthGroup(lengthSelect && lengthSelect.value);
        var widthGroup = chainWidthGroup(widthSelect && widthSelect.value);
        var normalizedColor = color.toLowerCase();
        var matchingPreview = previewItems.find(function (item) {
          return (item.getAttribute('data-chain-preview-color') || '').toLowerCase() === normalizedColor &&
            item.getAttribute('data-chain-length-group') === lengthGroup &&
            item.getAttribute('data-chain-width-group') === widthGroup;
        });

        if (matchingPreview) {
          var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
          selectMedia(mediaItems.indexOf(matchingPreview));
          return;
        }

        selectMediaForChainColor(color);
      }

      function updateProductCartState() {
        var form = root.querySelector('[data-product-form]');
        var variantInput = form && form.querySelector('[name="id"]');
        var addButton = form && form.querySelector('[data-product-add]');
        var purchaseRow = form && form.querySelector('[data-product-purchase-row]');
        var quantityField = form && form.querySelector('[data-product-quantity]');

        if (!variantInput || !addButton) return;

        var selectedOption = variantInput.options ? variantInput.options[variantInput.selectedIndex] : null;
        var variantId = variantInput.value;
        var availabilityValue = variantInput.getAttribute('data-available');
        var available = selectedOption
          ? !selectedOption.disabled
          : availabilityValue
            ? availabilityValue === 'true'
            : !addButton.hasAttribute('disabled');
        var price = selectedOption ? selectedOption.getAttribute('data-price') : variantInput.getAttribute('data-price') || '';
        var priceCents = Number(variantInput.getAttribute('data-price-cents')) || 0;
        var addLabel = price ? 'Add to cart · ' + price : addButton.getAttribute('data-add-label') || 'Add to cart';
        var inCart = isVariantInCart(variantId);
        var hasFixedQuantity = variantInput.getAttribute('data-fixed-quantity') === 'true';

        updateProductAddButton(addButton, variantId, available && priceCents > 0, addLabel);

        if (!inCart && priceCents <= 0) {
          addButton.disabled = true;
          addButton.textContent = 'Pricing unavailable';
        }

        if (purchaseRow) {
          purchaseRow.classList.toggle('is-in-cart', inCart);
          purchaseRow.classList.toggle('has-fixed-quantity', hasFixedQuantity);
        }

        if (quantityField) {
          quantityField.hidden = inCart || hasFixedQuantity || quantityField.hasAttribute('data-product-fixed-quantity');
        }

        updateCustomChainBuilder();
        updateCalibratedClaspBuilder();
      }

      function updateSelectedVariant(event) {
        var picker = event.target.closest('[data-product-option-picker]');
        if (!picker) return;

        var status = picker.querySelector('[data-product-option-status]');
        var selectedValues = Array.prototype.slice.call(picker.querySelectorAll('[data-product-option-select]')).map(function (select) {
          var option = select.options[select.selectedIndex];
          return option && option.getAttribute('data-option-value-id');
        }).filter(Boolean);

        if (!selectedValues.length) return;

        if (optionRequestController) optionRequestController.abort();
        optionRequestController = window.AbortController ? new AbortController() : null;

        picker.setAttribute('aria-busy', 'true');
        Array.prototype.forEach.call(picker.querySelectorAll('select'), function (select) {
          select.disabled = true;
        });
        if (status) status.textContent = 'Updating configuration…';

        var separator = picker.getAttribute('data-product-url').indexOf('?') === -1 ? '?' : '&';
        var requestUrl = picker.getAttribute('data-product-url') + separator +
          'section_id=' + encodeURIComponent(picker.getAttribute('data-section-id')) +
          '&option_values=' + encodeURIComponent(selectedValues.join(','));
        var requestOptions = optionRequestController ? { signal: optionRequestController.signal } : {};

        fetch(requestUrl, requestOptions)
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load this configuration.');
            return response.text();
          })
          .then(function (responseText) {
            var parsed = new DOMParser().parseFromString(responseText, 'text/html');
            var nextRoot = parsed.querySelector('[data-product-presale]');
            var nextPicker = nextRoot && nextRoot.querySelector('[data-product-option-picker]');
            var nextInput = nextRoot && nextRoot.querySelector('[data-product-form] [name="id"]');

            if (!nextRoot || !nextPicker || !nextInput || !nextInput.value) {
              throw new Error('This configuration is not available.');
            }

            var currentInput = root.querySelector('[data-product-form] [name="id"]');
            var currentPrice = root.querySelector('[data-product-selected-price]');
            var nextPrice = nextRoot.querySelector('[data-product-selected-price]');
            var currentPayFull = root.querySelector('[data-product-pay-full] strong');
            var nextPayFull = nextRoot.querySelector('[data-product-pay-full] strong');
            var currentPrompt = root.querySelector('[data-product-payment-prompt]');
            var nextPrompt = nextRoot.querySelector('[data-product-payment-prompt]');
            var currentAffirm = root.querySelector('.affirm-as-low-as');
            var nextAffirm = nextRoot.querySelector('.affirm-as-low-as');
            var currentSpecifications = root.querySelector('[data-product-variant-specifications]');
            var nextSpecifications = nextRoot.querySelector('[data-product-variant-specifications]');

            currentInput.value = nextInput.value;
            currentInput.setAttribute('data-price', nextInput.getAttribute('data-price') || '');
            currentInput.setAttribute('data-price-cents', nextInput.getAttribute('data-price-cents') || '0');
            currentInput.setAttribute('data-available', nextInput.getAttribute('data-available') || 'false');
            currentInput.setAttribute('data-fixed-quantity', nextInput.getAttribute('data-fixed-quantity') || 'false');

            if (currentPrice && nextPrice) currentPrice.innerHTML = nextPrice.innerHTML;
            if (currentPayFull && nextPayFull) currentPayFull.textContent = nextPayFull.textContent;
            if (currentPrompt && nextPrompt) currentPrompt.hidden = nextPrompt.hidden;
            if (currentAffirm && nextAffirm) currentAffirm.setAttribute('data-amount', nextAffirm.getAttribute('data-amount') || '0');
            if (currentSpecifications && nextSpecifications) currentSpecifications.innerHTML = nextSpecifications.innerHTML;

            picker.replaceWith(nextPicker);
            updateProductCartState();
            updateCustomChainBuilder();
            updateCalibratedClaspBuilder();
            refreshAffirmMessaging();

            if (window.history && window.history.replaceState) {
              var pageUrl = new URL(window.location.href);
              pageUrl.searchParams.set('variant', nextInput.value);
              window.history.replaceState({}, '', pageUrl.toString());
            }
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            picker.removeAttribute('aria-busy');
            Array.prototype.forEach.call(picker.querySelectorAll('select'), function (select) {
              select.disabled = false;
            });
            if (status) status.textContent = error && error.message ? error.message : 'Unable to update this configuration.';
          });
      }

      root.addEventListener('click', function (event) {
        var target = event.target;
        var mediaButton = target && target.closest ? target.closest('[data-product-media-thumb]') : null;
        var paymentModeButton = target && target.closest ? target.closest('[data-product-payment-mode]') : null;
        var providerButton = target && target.closest ? target.closest('[data-product-provider]') : null;

        if (mediaButton && root.contains(mediaButton)) {
          selectMedia(Number(mediaButton.getAttribute('data-product-media-thumb')) || 0);
          return;
        }

        if (paymentModeButton && root.contains(paymentModeButton)) {
          var paymentModeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-product-payment-mode]'));
          var financingPanel = root.querySelector('[data-product-financing-panel]');
          var payFullPanel = root.querySelector('[data-product-pay-full]');
          var showPlans = paymentModeButton.getAttribute('data-product-payment-mode') === 'plans';

          paymentModeButtons.forEach(function (peer) {
            var isActive = peer === paymentModeButton;
            peer.classList.toggle('is-active', isActive);
            peer.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          if (financingPanel) financingPanel.hidden = !showPlans;
          if (payFullPanel) payFullPanel.hidden = showPlans;
          rememberPaymentSelection();
          return;
        }

        if (providerButton && root.contains(providerButton)) {
          var provider = providerButton.getAttribute('data-product-provider');
          var providerButtons = Array.prototype.slice.call(root.querySelectorAll('[data-product-provider]'));
          var providerCopy = Array.prototype.slice.call(root.querySelectorAll('[data-product-provider-copy]'));

          providerButtons.forEach(function (peer) {
            var isActive = peer === providerButton;
            peer.classList.toggle('is-active', isActive);
            peer.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          providerCopy.forEach(function (copy) {
            copy.hidden = copy.getAttribute('data-product-provider-copy') !== provider;
          });
          refreshAffirmMessaging();
          rememberPaymentSelection();
        }
      });

      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('[data-ring-size-select]')) {
          updateRingSizing();
          return;
        }

        if (event.target && event.target.matches('[data-product-option-select]')) {
          updateSelectedVariant(event);
          return;
        }

        if (event.target && event.target.matches('[data-product-form] [name="id"]')) {
          updateProductCartState();
          return;
        }

        if (event.target && event.target.closest && event.target.closest('[data-custom-chain-builder]')) {
          if (event.target.matches('[data-chain-media-color]')) {
            selectMediaForChainColor(event.target.getAttribute('data-chain-media-color'));
          }
          updateCustomChainBuilder();
          return;
        }

        if (event.target && event.target.closest && event.target.closest('[data-calibrated-clasp-builder]')) {
          updateCalibratedClaspBuilder();
        }
      });

      root.addEventListener('input', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-custom-chain-builder]')) {
          updateCustomChainBuilder();
        }
      });

      var productForm = root.querySelector('[data-product-form]');

      if (productForm && customChainBuilder) {
        productForm.addEventListener('submit', function (event) {
          var addButton = productForm.querySelector('[data-product-add]');
          var status = customChainBuilder.querySelector('[data-chain-builder-status]');

          event.preventDefault();
          event.stopPropagation();

          if (!cartDrawerInstance || typeof cartDrawerInstance.addItems !== 'function') {
            if (status) status.textContent = 'The shopping bag is unavailable. Please refresh and try again.';
            return;
          }

          if (status) status.textContent = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Adding your configuration…';
          }

          cartDrawerInstance.addItems(buildCustomChainCartItems())
            .then(function () {
              if (status) status.textContent = 'Your custom ' + customProductNoun + ' is in the shopping bag.';
              updateProductCartState();
            })
            .catch(function (error) {
              if (status) status.textContent = error && error.message ? error.message : 'This custom ' + customProductNoun + ' could not be added.';
              updateProductCartState();
            });
        });
      }

      if (productForm && calibratedClaspBuilder) {
        productForm.addEventListener('submit', function (event) {
          var addButton = productForm.querySelector('[data-product-add]');
          var status = calibratedClaspBuilder.querySelector('[data-calibrated-clasp-status]');

          event.preventDefault();
          event.stopPropagation();

          if (!cartDrawerInstance || typeof cartDrawerInstance.addItems !== 'function') {
            if (status) status.textContent = 'The shopping bag is unavailable. Please refresh and try again.';
            return;
          }

          if (status) status.textContent = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Adding your configuration…';
          }

          cartDrawerInstance.addItems(buildCalibratedClaspCartItems())
            .then(function () {
              if (status) status.textContent = 'Your chain is in the shopping bag.';
              updateProductCartState();
            })
            .catch(function (error) {
              if (status) status.textContent = error && error.message ? error.message : 'This chain could not be added.';
              updateProductCartState();
            });
        });
      }

      document.addEventListener('theme:cart-updated', updateProductCartState);
      initializeRingSizing();
      // Restore only known controls; URL values never become executable selectors.
      ['payment_mode', 'payment_provider'].forEach(function (parameter) {
        var attribute = parameter === 'payment_mode' ? 'data-product-payment-mode' : 'data-product-provider';
        var requested = selectionParams.get(parameter);
        Array.prototype.forEach.call(root.querySelectorAll('[' + attribute + ']'), function (button) {
          if (button.getAttribute(attribute) === requested) button.click();
        });
      });
      updatePurchaseSelection();
      hydrateCustomChainFromQuery();
      updateProductCartState();
      updateCustomChainBuilder();
      updateCalibratedClaspBuilder();
    });
  }

  function initHomeChainBuilders() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-home-chain-builder]'), function (root) {
      if (root.homeChainBuilderInitialized) return;
      root.homeChainBuilderInitialized = true;

      var productDataElements = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-product-data]'));
      var productDataByConstruction = {};
      var productData = { currency: 'USD', optionNames: [], variants: [] };
      var constructionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-construction]'));
      var constructionEyebrow = root.querySelector('[data-home-chain-construction-eyebrow]');
      var constructionTitle = root.querySelector('[data-home-chain-construction-title]');
      var constructionCopy = root.querySelector('[data-home-chain-construction-copy]');
      var currentConstruction = 'solid';
      var stepButtons = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-step]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-panel]'));
      var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-input]'));
      var propertyFields = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-property]'));
      var detailPanels = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-detail-panel]'));
      var preview = root.querySelector('[data-home-chain-preview]');
      var foundation = root.querySelector('[data-home-chain-foundation]');
      var summary = root.querySelector('[data-home-chain-summary]');
      var price = root.querySelector('[data-home-chain-price]');
      var continueLink = root.querySelector('[data-home-chain-continue]');
      var addButton = root.querySelector('[data-home-chain-add]');
      var addLabel = root.querySelector('[data-home-chain-add-label]');
      var status = root.querySelector('[data-home-chain-status]');
      var stepCount = root.querySelector('[data-home-chain-step-count]');
      var currentVariant = null;
      var activeVariantKey = '';
      var pendingVariantKey = '';
      var variantRequestController = null;
      var resolvedVariants = {};
      var failedVariantKeys = {};
      var defaultAddLabel = addLabel ? addLabel.textContent.trim() : 'Add custom chain';

      productDataElements.forEach(function (element) {
        try {
          productDataByConstruction[element.getAttribute('data-construction') || 'solid'] = JSON.parse(element.textContent);
        } catch (error) {
          productDataByConstruction[element.getAttribute('data-construction') || 'solid'] = { currency: 'USD', optionNames: [], variants: [] };
        }
      });
      productData = productDataByConstruction.solid || productData;

      function normalizeValue(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/&prime;|[\"'″]/g, '')
          .replace(/millimeters?|inches?|inch|\bmm\b|\bin\b/g, '')
          .replace(/[^a-z0-9]/g, '');
      }

      function chainLengthGroup(value) {
        var length = Number.parseFloat(value) || 0;
        if (length <= 22) return 'short';
        if (length <= 30) return 'medium';
        return 'long';
      }

      function chainWidthGroup(value) {
        var width = Number.parseFloat(value) || 0;
        if (width <= 10) return 'narrow';
        if (width <= 14) return 'medium';
        return 'wide';
      }

      function inputValue(param) {
        var matchingInputs = inputs.filter(function (input) {
          return input.getAttribute('data-builder-param') === param;
        });
        var selected = matchingInputs.find(function (input) {
          return input.type !== 'radio' || input.checked;
        });
        return selected ? selected.value : '';
      }

      function selectedCustomizationInputs() {
        return inputs.filter(function (input) {
          return (input.type === 'radio' || input.type === 'checkbox') && input.checked && input.hasAttribute('data-builder-group');
        });
      }

      function updateMinimumLengthChoices(dimensions) {
        var selectedLength = Number.parseFloat(dimensions.length) || 0;
        var needsFallback = false;

        inputs.forEach(function (input) {
          var minimumLength = Number.parseFloat(input.getAttribute('data-builder-min-length')) || 0;
          if (!minimumLength) return;

          var unavailable = selectedLength < minimumLength;
          var choice = input.closest('.home-chain-builder__choice');
          input.disabled = unavailable;
          if (choice) {
            choice.classList.toggle('is-disabled', unavailable);
            choice.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
          }
          if (unavailable && input.checked) needsFallback = true;
        });

        if (needsFallback) {
          var defaultLock = inputs.find(function (input) {
            return input.getAttribute('data-builder-param') === 'chain_lock' && input.value === 'Handmade Box Lock';
          });
          if (defaultLock) defaultLock.checked = true;
        }
      }

      function updateDetailPanels(customizations) {
        detailPanels.forEach(function (panel) {
          var detailName = panel.getAttribute('data-home-chain-detail-panel');
          var isActive = customizations.some(function (input) {
            return input.getAttribute('data-builder-detail') === detailName;
          });
          panel.hidden = !isActive;
        });
      }

      function visiblePropertyValue(propertyName) {
        var field = propertyFields.find(function (candidate) {
          var panel = candidate.closest('[data-home-chain-detail-panel]');
          return candidate.getAttribute('data-home-chain-property') === propertyName && (!panel || !panel.hidden);
        });
        return field ? String(field.value || '').trim() : '';
      }

      function selectedDimensions() {
        return {
          karat: inputValue('karat'),
          length: inputValue('length'),
          width: inputValue('width')
        };
      }

      function variantKey(dimensions) {
        return [currentConstruction, dimensions.karat, dimensions.length, dimensions.width].map(normalizeValue).join(':');
      }

      function findVariant(dimensions) {
        var key = variantKey(dimensions);

        if (Object.prototype.hasOwnProperty.call(resolvedVariants, key)) {
          return resolvedVariants[key];
        }

        return (productData.variants || []).find(function (variant) {
          if (!variant.available) return false;

          return (productData.optionNames || []).every(function (optionName, index) {
            var normalizedName = normalizeValue(optionName);
            var dimension = normalizedName.indexOf('karat') !== -1 ? 'karat' :
              normalizedName.indexOf('length') !== -1 ? 'length' :
                normalizedName.indexOf('width') !== -1 ? 'width' : '';

            if (!dimension) return true;
            return normalizeValue(variant.options[index]) === normalizeValue(dimensions[dimension]);
          });
        });
      }

      function optionValueIds(dimensions) {
        var valuesByDimension = dimensions || selectedDimensions();

        return (productData.optionNames || []).map(function (optionName) {
          var normalizedName = normalizeValue(optionName);
          var dimension = normalizedName.indexOf('karat') !== -1 ? 'karat' :
            normalizedName.indexOf('length') !== -1 ? 'length' :
              normalizedName.indexOf('width') !== -1 ? 'width' : '';
          var optionGroup = (productData.optionValues || []).find(function (group) {
            return normalizeValue(group.name) === normalizedName;
          });
          var optionValue = optionGroup && (optionGroup.values || []).find(function (value) {
            return normalizeValue(value.value) === normalizeValue(valuesByDimension[dimension]);
          });

          return optionValue && optionValue.id;
        }).filter(Boolean);
      }

      function resolveVariant(dimensions, key) {
        if (!productData.productUrl || pendingVariantKey === key || failedVariantKeys[key]) return;

        var selectedOptionValueIds = optionValueIds(dimensions);
        if (selectedOptionValueIds.length !== (productData.optionNames || []).length) {
          failedVariantKeys[key] = true;
          return;
        }

        if (variantRequestController) variantRequestController.abort();
        variantRequestController = window.AbortController ? new AbortController() : null;
        pendingVariantKey = key;

        var separator = productData.productUrl.indexOf('?') === -1 ? '?' : '&';
        var requestUrl = productData.productUrl + separator +
          'view=variant-resolver&option_values=' + encodeURIComponent(selectedOptionValueIds.join(','));
        var requestOptions = variantRequestController ? { signal: variantRequestController.signal } : {};

        fetch(requestUrl, requestOptions)
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load this configuration.');
            return response.json();
          })
          .then(function (responseData) {
            if (!responseData || !responseData.variant) {
              throw new Error('This configuration is not available.');
            }

            resolvedVariants[key] = responseData.variant;
            delete failedVariantKeys[key];
            if (pendingVariantKey === key) pendingVariantKey = '';
            if (activeVariantKey === key) updateBuilder();
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            failedVariantKeys[key] = true;
            if (pendingVariantKey === key) pendingVariantKey = '';

            if (activeVariantKey === key) {
              if (price) price.textContent = 'Configuration unavailable';
              if (addLabel) addLabel.textContent = 'Configuration unavailable';
              if (addButton) {
                addButton.disabled = true;
                addButton.setAttribute('aria-disabled', 'true');
              }
              if (status) status.textContent = error && error.message ? error.message : 'Unable to load this configuration.';
            }
          });
      }

      function selectPreviewMedia(color, length, width) {
        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-home-chain-media]'));
        var normalizedColor = color.toLowerCase();
        var lengthGroup = chainLengthGroup(length);
        var widthGroup = chainWidthGroup(width);
        var matchingMedia = mediaItems.find(function (item) {
          return item.hasAttribute('data-home-chain-builder-media') &&
            (item.getAttribute('data-home-chain-media-color') || '').toLowerCase() === normalizedColor &&
            item.getAttribute('data-chain-length-group') === lengthGroup &&
            item.getAttribute('data-chain-width-group') === widthGroup;
        });

        if (!matchingMedia) {
          matchingMedia = mediaItems.find(function (item) {
            return !item.hasAttribute('data-home-chain-builder-media') &&
              (item.getAttribute('data-home-chain-media-color') || '').toLowerCase() === normalizedColor;
          });
        }

        if (!matchingMedia && color === 'Yellow Gold') matchingMedia = mediaItems[0];
        if (!matchingMedia) return;

        mediaItems.forEach(function (item) {
          var isActive = item === matchingMedia;
          item.hidden = !isActive;
          item.classList.toggle('is-active', isActive);
        });
      }

      function selectStep(stepName) {
        var selectedIndex = 0;

        stepButtons.forEach(function (button, index) {
          var isActive = button.getAttribute('data-home-chain-step') === stepName;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) selectedIndex = index;
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-home-chain-panel') === stepName;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        if (stepCount) {
          stepCount.textContent = String(selectedIndex + 1).padStart(2, '0') + ' / ' + String(stepButtons.length).padStart(2, '0');
        }
      }

      function updateBuilder() {
        var dimensions = selectedDimensions();
        updateMinimumLengthChoices(dimensions);
        var karat = dimensions.karat;
        var length = dimensions.length;
        var width = dimensions.width;
        var color = inputValue('chain_color') || 'Yellow Gold';
        var finish = inputValue('chain_finish') || 'Classic finish';
        var lock = inputValue('chain_lock') || 'Handmade Box Lock';
        var button = inputValue('chain_button') || 'Standard Gold Button';
        var pricingEnabled = productData.pricingEnabled !== false;
        var key = variantKey(dimensions);
        var variant = pricingEnabled ? findVariant(dimensions) : null;
        var selectedCustomizations = selectedCustomizationInputs();
        updateDetailPanels(selectedCustomizations);
        var addonPrice = selectedCustomizations.reduce(function (total, input) {
          return total + (Number(input.getAttribute('data-addon-price-cents')) || 0);
        }, 0);
        var totalPrice = variant ? Number(variant.price) + addonPrice : 0;
        var params = new URLSearchParams();
        var colorKey = color.toLowerCase().indexOf('white') !== -1 ? 'white' : color.toLowerCase().indexOf('rose') !== -1 ? 'rose' : 'yellow';

        Array.prototype.forEach.call(root.querySelectorAll('.home-chain-builder__choice'), function (choice) {
          var selectedInput = choice.querySelector('input');
          choice.classList.toggle('is-selected', Boolean(selectedInput && selectedInput.checked));
        });

        var buttonDetail = button === 'Diamond Button' ? visiblePropertyValue('Button shape') :
          button === 'Gemstone Button' ? visiblePropertyValue('Gemstone') : '';
        var summaryParts = [currentConstruction === 'semi-solid' ? 'Semi-solid' : 'Solid', karat, length + '″', width + ' mm', color, finish, lock, button];
        if (buttonDetail) summaryParts.push(buttonDetail);
        if (selectedCustomizations.some(function (input) { return input.getAttribute('data-builder-group') === 'Engraving'; })) summaryParts.push('Engraving');

        if (foundation) foundation.textContent = (currentConstruction === 'semi-solid' ? 'Semi-solid · ' : 'Solid · ') + karat + ' · ' + length + '″ · ' + width + ' mm';
        if (summary) summary.textContent = summaryParts.join(' · ');
        if (preview) preview.setAttribute('data-preview-color', colorKey);
        selectPreviewMedia(color, length, width);

        activeVariantKey = key;
        currentVariant = variant || null;

        var financingSource = root.querySelector('[data-monthly-source]');
        var financingAmount = variant ? totalPrice : 0;
        if (financingSource && Number(financingSource.getAttribute('data-amount')) !== financingAmount) {
          financingSource.textContent = '';
          financingSource.setAttribute('data-amount', String(financingAmount));
          refreshAffirmMessaging();
        }

        if (variant) {
          if (status && status.textContent === 'Checking current price…') status.textContent = '';
          params.set('variant', variant.id);
          if (price) price.textContent = formatCurrency(totalPrice, productData.currency || 'USD');
          if (addLabel) addLabel.textContent = defaultAddLabel;
        } else if (pricingEnabled && !failedVariantKeys[key]) {
          if (price) price.textContent = 'Checking current price…';
          if (addLabel) addLabel.textContent = 'Checking availability…';
          if (status) status.textContent = 'Checking current price…';
          resolveVariant(dimensions, key);
        } else if (price) {
          price.textContent = pricingEnabled ? 'Configuration unavailable' : '';
          if (addLabel) addLabel.textContent = pricingEnabled ? 'Configuration unavailable' : 'Semi-solid pricing coming soon';
        }

        inputs.forEach(function (input) {
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          var paramName = input.getAttribute('data-builder-param');
          if (paramName) params.set(paramName, input.value);
        });

        propertyFields.forEach(function (field) {
          var panel = field.closest('[data-home-chain-detail-panel]');
          var queryParam = field.getAttribute('data-builder-query-param');
          if (!queryParam || (panel && panel.hidden) || !String(field.value || '').trim()) return;
          params.set(queryParam, field.value);
        });

        if (continueLink) {
          var productUrl = productData.productUrl || root.getAttribute(currentConstruction === 'semi-solid' ? 'data-semi-solid-product-url' : 'data-solid-product-url') || '/products/custom-cuban-link-chain';
          continueLink.href = productUrl + '?' + params.toString();
          continueLink.classList.toggle('is-disabled', !variant);
          continueLink.setAttribute('aria-disabled', variant ? 'false' : 'true');
        }

        if (addButton) {
          addButton.disabled = !variant || !pricingEnabled;
          addButton.setAttribute('aria-disabled', variant ? 'false' : 'true');
        }
      }

      function buildCartItems() {
        if (!currentVariant) return [];

        var configurationId = 'CC-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
        var properties = {
          '_Configuration ID': configurationId,
          'Construction': currentConstruction === 'semi-solid' ? 'Semi-solid' : 'Solid'
        };
        var customizations = selectedCustomizationInputs();
        var items = [];

        customizations.forEach(function (input) {
          var group = input.getAttribute('data-builder-group');

          if (group) properties[group] = input.value;
        });

        propertyFields.forEach(function (field) {
          var panel = field.closest('[data-home-chain-detail-panel]');
          var propertyName = field.getAttribute('data-home-chain-property');
          var propertyValue = String(field.value || '').trim();
          if (!propertyName || !propertyValue || (panel && panel.hidden)) return;
          properties[propertyName] = propertyValue;
        });

        items.push({
          id: Number(currentVariant.id),
          quantity: 1,
          properties: properties
        });

        customizations.forEach(function (input) {
          var addonVariantId = Number(input.getAttribute('data-addon-variant-id'));
          if (!addonVariantId) return;

          items.push({
            id: addonVariantId,
            quantity: 1,
            properties: {
              '_Configuration ID': configurationId,
              '_Configuration parent': String(currentVariant.id)
            }
          });
        });

        return items;
      }

      stepButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          selectStep(button.getAttribute('data-home-chain-step'));
        });
      });

      constructionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          currentConstruction = button.getAttribute('data-home-chain-construction') || 'solid';
          productData = productDataByConstruction[currentConstruction] || { currency: 'USD', optionNames: [], variants: [], pricingEnabled: false };
          if (status) status.textContent = '';
          constructionButtons.forEach(function (candidate) {
            var isActive = candidate === button;
            candidate.classList.toggle('is-active', isActive);
            candidate.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          var isSemiSolid = currentConstruction === 'semi-solid';
          if (constructionEyebrow) constructionEyebrow.textContent = isSemiSolid
            ? 'Custom Semi-Solid Cuban Link Chain'
            : 'Custom Solid Cuban Link Chain';
          if (constructionTitle) constructionTitle.textContent = isSemiSolid
            ? 'Effortless by design.'
            : 'The weight of true luxury.';
          if (constructionCopy) constructionCopy.textContent = isSemiSolid
            ? 'A lighter karat-gold construction, expertly assembled and hand-finished for effortless everyday luxury.'
            : 'Handmade in solid karat gold, every link is shaped and polished for enduring weight and presence.';
          updateBuilder();
        });
      });

      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          delete failedVariantKeys[variantKey(selectedDimensions())];
          if (status) status.textContent = '';
          updateBuilder();
        });
      });

      propertyFields.forEach(function (field) {
        field.addEventListener('change', updateBuilder);
        field.addEventListener('input', updateBuilder);
      });

      if (addButton) {
        addButton.addEventListener('click', function () {
          var items = buildCartItems();

          if (!items.length) {
            if (status) status.textContent = 'This configuration is unavailable.';
            return;
          }

          if (!cartDrawerInstance || typeof cartDrawerInstance.addItems !== 'function') {
            if (status) status.textContent = 'The shopping bag is unavailable. Please refresh and try again.';
            return;
          }

          if (status) status.textContent = '';
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Adding your configuration…';

          cartDrawerInstance.addItems(items)
            .then(function () {
              if (status) status.textContent = 'Your custom chain is in the shopping bag.';
            })
            .catch(function (error) {
              if (status) status.textContent = error && error.message ? error.message : 'This custom chain could not be added.';
            })
            .then(updateBuilder);
        });
      }

      selectStep('foundation');

      var defaultConstructionButton = constructionButtons.find(function (button) {
        return button.getAttribute('data-home-chain-construction') === 'solid';
      });

      if (defaultConstructionButton) {
        defaultConstructionButton.click();
      } else {
        updateBuilder();
      }
    });
  }

  function initTheme() {
    hydrateCartVariantState();
    initHorizontalStages();
    initCartDrawer();
    initProductPresale();
    initHomeChainBuilders();
    syncCartPaymentPreference();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
  } else {
    initTheme();
  }

  document.addEventListener('shopify:section:load', initTheme);
  document.addEventListener('shopify:section:unload', initTheme);
})();
